
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jtfsl", function(module, exports) {
/**
 * @generated SignedSource<<7dc99622ff8ab2775d75b231f507aa88>>
 * @relayHash 0dd246a45e06b932ab1b8570b0e2a26f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63
const $8272d98e33ae5f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "groupsWithId",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0dd246a45e06b932ab1b8570b0e2a26f",
            "id": "9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63",
            "metadata": {},
            "name": "AudienceSegmentationContextProviderQuery",
            "operationKind": "query",
            "text": "query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id,confluence{groupsWithId{id}}}}"
        }
    };
}();
$8272d98e33ae5f0d$var$node.hash = "d01bf7959fed02b6636fa27826de406a";
var $8272d98e33ae5f0d$export$2e2bcd8739ae039 = $8272d98e33ae5f0d$var$node;
module.exports["default"] = $8272d98e33ae5f0d$export$2e2bcd8739ae039;

});

parcelRegister("lqVBP", function(module, exports) {

var $k9SFD = parcelRequire("k9SFD");

const $9e664374a2d44de5$var$resolveMentionNodeData = ({ id: accountId })=>({
        avatarUrl: `/wiki/aa-avatar/${encodeURIComponent(accountId)}`,
        isAvatarImagePreShaped: true
    });
const $9e664374a2d44de5$export$38ae2a33ee19fe82 = ()=>new (0, $k9SFD.MentionNodeDataProvider)(()=>Promise.resolve({}), $9e664374a2d44de5$var$resolveMentionNodeData);
module.exports["createMentionNodeDataProvider"] = $9e664374a2d44de5$export$38ae2a33ee19fe82;

});

parcelRegister("hEeUR", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");


var $1a6Dn = parcelRequire("1a6Dn");


var $8WfxO = parcelRequire("8WfxO");


var $9FraN = parcelRequire("9FraN");


var $fyKZ5 = parcelRequire("fyKZ5");

const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $9FraN.useForgePageBannerListener)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== atlGeneralWebPanelHeight || $[2] !== forgePageBannerHeight || $[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t0
        }, (flags, floatingBanners)=>{
            const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
            const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
            const stickyTableHeaderConfig = {
                offsetTop: pageHeaderAndBannerHeight,
                defaultScrollRootId_DO_NOT_USE: "AkMainContent",
                shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyKZ5.ADFRendererComponent), {
                flags: flags,
                ...stickyTableHeaderConfig,
                ...props
            });
        });
        $[1] = atlGeneralWebPanelHeight;
        $[2] = forgePageBannerHeight;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';
module.exports["ADFRenderer"] = $2a9f51add9ac11ab$export$7cfa481653c48265;

});

parcelRegister("9FraN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");

const $134d01bd64a6ba9b$export$e43ca933d3c87145 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $134d01bd64a6ba9b$var$getForgeAppsHeight();
        $[0] = t0;
    } else t0 = $[0];
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $cozmU.useState)(t0);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    let t1;
    let t2;
    if ($[1] !== isForgePageBannerFixed) {
        t1 = ()=>{
            const listener = (e)=>{
                if ((0, $6mKj3.expVal)("confluence_pgxp_p2m_batch_1", "isEnabled", false)) setForgeAppsHeight(e?.detail?.height ?? 0);
                else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
            };
            if (isForgePageBannerFixed) document.addEventListener("forgePageBannerHeightUpdated", listener);
            return ()=>{
                if (isForgePageBannerFixed) document.removeEventListener("forgePageBannerHeightUpdated", listener);
            };
        };
        t2 = [
            isForgePageBannerFixed
        ];
        $[1] = isForgePageBannerFixed;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== forgeAppsHeight || $[5] !== isForgePageBannerFixed) {
        t3 = {
            isForgePageBannerFixed: isForgePageBannerFixed,
            forgePageBannerHeight: forgeAppsHeight
        };
        $[4] = forgeAppsHeight;
        $[5] = isForgePageBannerFixed;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $cozmU.useState)($134d01bd64a6ba9b$var$getForgeAppsHeight());
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    (0, $cozmU.useEffect)(()=>{
        const listener = (e)=>{
            if ((0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) setForgeAppsHeight(e?.detail?.height ?? 0);
            else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
        };
        if (isForgePageBannerFixed) document.addEventListener('forgePageBannerHeightUpdated', listener);
        return ()=>{
            if (isForgePageBannerFixed) document.removeEventListener('forgePageBannerHeightUpdated', listener);
        };
    }, [
        isForgePageBannerFixed
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        forgePageBannerHeight: forgeAppsHeight
    };
};
const $134d01bd64a6ba9b$var$getForgeAppsHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height')) || 0;
};
module.exports["useForgePageBannerListener"] = $134d01bd64a6ba9b$export$e43ca933d3c87145;

});

parcelRegister("fyKZ5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eNbr2 = parcelRequire("eNbr2");


var $kwzZh = parcelRequire("kwzZh");


var $3BY7M = parcelRequire("3BY7M");


var $iDrrr = parcelRequire("iDrrr");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");


var $7VJPz = parcelRequire("7VJPz");


var $fgQGl = parcelRequire("fgQGl");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $hSHWm = parcelRequire("hSHWm");


var $b2eAY = parcelRequire("b2eAY");


var $7BsWq = parcelRequire("7BsWq");


var $brsfB = parcelRequire("brsfB");



var $26BUI = parcelRequire("26BUI");


var $gXrHX = parcelRequire("gXrHX");


var $1SPMi = parcelRequire("1SPMi");


var $yuV6Z = parcelRequire("yuV6Z");


var $8pcS0 = parcelRequire("8pcS0");


var $kLzei = parcelRequire("kLzei");


var $hMB4W = parcelRequire("hMB4W");


var $iP9x4 = parcelRequire("iP9x4");


var $3WO8q = parcelRequire("3WO8q");

var $gxhb8 = parcelRequire("gxhb8");


var $dtVue = parcelRequire("dtVue");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $lqVBP = parcelRequire("lqVBP");


var $8WQTF = parcelRequire("8WQTF");


var $jyPfN = parcelRequire("jyPfN");


var $7W8i8 = parcelRequire("7W8i8");



var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $gj42z = parcelRequire("gj42z");


var $4GlQ9 = parcelRequire("4GlQ9");


var $dPJCf = parcelRequire("dPJCf");


var $4o1RV = parcelRequire("4o1RV");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $6M71K = parcelRequire("6M71K");


var $6GQtz = parcelRequire("6GQtz");


var $dXIrr = parcelRequire("dXIrr");


var $9Eka4 = parcelRequire("9Eka4");


var $BjpgS = parcelRequire("BjpgS");


var $94rDp = parcelRequire("94rDp");


var $3jwuS = parcelRequire("3jwuS");


var $6Trhx = parcelRequire("6Trhx");


var $edEsl = parcelRequire("edEsl");


var $5hfGu = parcelRequire("5hfGu");


var $9VON8 = parcelRequire("9VON8");


var $1P2f3 = parcelRequire("1P2f3");

const $1af8a83cb114ff50$var$EXTENSION_KEYS_TO_HIDE_WHILE_PENDING = [
    (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS
];
const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($1P2f3.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) providers.profilecardProvider = profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $eNbr2.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return {
        providerFactory: providerFactory,
        providers: providers
    };
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $iDrrr.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
// `parentProduct` is a query param set by Embedded Confluence hosts (e.g. `?parentProduct=JSM`).
const $1af8a83cb114ff50$var$useParentProduct = (0, $dPJCf.createSingleQueryParamHook)('parentProduct');
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS, getExtensionHandlers: getExtensionHandlers = $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS, eventHandlers: eventHandlers, appearance: appearance, contentMode: contentMode, adfStage: adfStage = 'stage0', portal: portal, onRendered: onRendered, onRendererRendered: onRendererRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, allowHeadingAnchorLinks: customAllowHeadingAnchorLinks, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, allowRendererContainerStyles: allowRendererContainerStyles, pageMode: pageMode, mentionNodeDataProvider: providedMentionNodeDataProvider, ...rest } = props;
    const intl = (0, $kSwu1.useIntl)();
    const [isTaskToggled, setIsTaskToggled] = (0, $cozmU.useState)(false);
    // The provider is transport only. Platform evaluates and records the experiment
    // when an eligible mention renders, including mentions in the control cohort.
    const defaultMentionNodeDataProvider = (0, $cozmU.useMemo)(()=>(0, $lqVBP.createMentionNodeDataProvider)(), []);
    const resolvedMentionNodeDataProvider = providedMentionNodeDataProvider ?? defaultMentionNodeDataProvider;
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const { storeOptions: storeOptions } = (0, $btIEy.useStoreOptions)(initialState, isPageSSR);
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const parentProduct = $1af8a83cb114ff50$var$useParentProduct();
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !isEmbedded && !(0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, isHideTitleInUrl: isHideTitleInUrl, timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $cozmU.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $cozmU.useState)(false);
    const pendingTaskPatchRef = (0, $cozmU.useRef)({
        states: new Map()
    });
    const flushTaskStatusPatch = (0, $cozmU.useCallback)(()=>{
        const pending = pendingTaskPatchRef.current;
        pendingTaskPatchRef.current = {
            states: new Map()
        };
        return {
            contentId: pending.contentId,
            contentType: pending.contentType,
            spaceKey: pending.spaceKey,
            taskStatusUpdates: Array.from(pending.states, ([localId, state])=>({
                    localId: localId,
                    state: state
                }))
        };
    }, []);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const spaceKey = props.spaceKey || pageContextSpaceKey;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $cozmU.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $cozmU.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $5hfGu.batchTaskUpdate)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $cozmU.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
        // Capture on toggle, not after the batched mutation resolves, so navigating away within
        // the batch interval still reconciles the cache.
        const pending = pendingTaskPatchRef.current;
        pending.contentId = contentId;
        pending.contentType = contentType;
        pending.spaceKey = spaceKey;
        pending.states.set(objectKey.localId, state);
    }, [
        taskBatcherRef,
        contentId,
        contentType,
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            if (isTaskToggled) {
                event.preventDefault();
                event.returnValue = ''; // This triggers the alert in all browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $cozmU.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $cozmU.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const mergedExtensionHandlers = (0, $cozmU.useMemo)(()=>{
        return {
            ...getExtensionHandlers?.(),
            ...extensionHandlers,
            ...(0, $b2eAY.getRendererCustomSitesExtensionHandlers)({
                contentId: contentId
            }),
            ...(0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandler = (0, $cozmU.useCallback)((error)=>{
        onError?.(error);
    }, [
        onError
    ]);
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    // ----------------------------------
    // When hiding content titles in URLs, also disable heading anchor links to prevent exposing UGC in generated anchor URLs.
    const shouldHideHeadingAnchorLinks = isHideTitleInUrl && (0, $6mKj3.expValEquals)('confluence_hide_content_title_in_url', 'isEnabled', true);
    // When the page is rendered inside a JSM Knowledge Base embed, disable heading anchor links.
    // The "Copy link to heading" affordance links back to Confluence and is not meaningful in the
    // JSM KB context (the article is surfaced under a JSM URL), so it is suppressed there.
    // `parentProduct` is `JSM` for agent view and `JSM-Portal` for customer portal view.
    const shouldHideHeadingAnchorLinksForJsmEmbed = isEmbedded && (parentProduct === 'JSM' || parentProduct === 'JSM-Portal');
    const allowHeadingAnchorLinks = (0, $cozmU.useMemo)(()=>shouldHideHeadingAnchorLinks || shouldHideHeadingAnchorLinksForJsmEmbed ? false : {
            ...customAllowHeadingAnchorLinks !== null && typeof customAllowHeadingAnchorLinks === 'object' ? customAllowHeadingAnchorLinks : undefined,
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }, [
        customAllowHeadingAnchorLinks,
        props.queryHash,
        shouldHideHeadingAnchorLinks,
        shouldHideHeadingAnchorLinksForJsmEmbed
    ]);
    // Build media viewer extensions to add the comments button to the preview header
    const mediaViewerExtensions = (0, $BjpgS.useMediaCommentExtensions)({
        isViewPage: true,
        analyticsSource: 'viewPageScreen',
        flags: flags
    });
    const fallbackMediaNameFetcher = (0, $cozmU.useMemo)(()=>contentId ? (0, $6Trhx.createFallbackMediaNameFetcher)(contentId) : undefined, [
        contentId
    ]);
    const media = (0, $cozmU.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            mediaViewerExtensions: mediaViewerExtensions,
            ssr: mediaSSR,
            fallbackMediaNameFetcher: (0, $6mKj3.expVal)('platform_editor_media_name_fallback', 'isEnabled', false) ? fallbackMediaNameFetcher : undefined
        }), [
        mediaSSR,
        mediaViewerExtensions,
        fallbackMediaNameFetcher
    ]);
    const CompetitorPromptWithAppearance = (0, $cozmU.useMemo)(()=>{
        return (competitorPromptProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dXIrr.PromptPopupContainer), {
                ...competitorPromptProps,
                editorAppearance: appearance
            });
    }, [
        appearance
    ]);
    const actionOptions = (0, $cozmU.useMemo)(()=>{
        const isFullPage = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
        if (isFullPage) return {
            hide: false,
            rovoChatAction: {
                optIn: true
            }
        };
    }, [
        appearance
    ]);
    const getResolvingPlaceholder = (0, $cozmU.useCallback)((url)=>window.__SSR_SMARTLINKS_TITLES__?.[url], []);
    const smartLinks = (0, $cozmU.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false,
            CompetitorPrompt: CompetitorPromptWithAppearance,
            actionOptions: actionOptions,
            ...(0, $6mKj3.expVal)('confluence_frontend_smartlinks_title_while_loading', 'isEnabled', false) ? {
                getResolvingPlaceholder: getResolvingPlaceholder
            } : undefined
        }), [
        actionOptions,
        shouldSSRsmartLinks,
        CompetitorPromptWithAppearance,
        getResolvingPlaceholder
    ]);
    const stickyHeaders = (0, $cozmU.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    const mergedDataProviders = (0, $cozmU.useMemo)(()=>$1af8a83cb114ff50$var$mergeDataProviders({
            contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
            contentId,
            spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
            spaceKey,
            pageContextContentId: pageContextContentId,
            cloudId: cloudId,
            userId: userId,
            flags: flags,
            featureFlags: featureFlags,
            push: push,
            intl: intl,
            providerFactory: dataProviders,
            profilecardProvider: profilecardProvider,
            isExternalShare: isExternalShareRequest,
            handleActionToggle: handleActionToggle,
            hasViewUserProfilePermission: hasViewUserProfilePermission,
            handleInviteItemClick: openCoreInvites,
            userRole: userRole,
            mediaToken: mediaToken,
            emojiResourceParams: emojiResourceParams
        }), [
        contentId,
        spaceKey,
        pageContextContentId,
        cloudId,
        userId,
        flags,
        featureFlags,
        push,
        intl,
        dataProviders,
        profilecardProvider,
        isExternalShareRequest,
        handleActionToggle,
        hasViewUserProfilePermission,
        openCoreInvites,
        userRole,
        mediaToken,
        emojiResourceParams
    ]);
    const SyncedBlockNodeComponent = (0, $9Eka4.useMemoizedSyncedBlockProviderNodeComponent)({
        doc: document,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        mergedDataProviderDefinitions: mergedDataProviders.providers,
        // Pass the same sticky header config as the page so tables in synced blocks use
        // the same scroll root (e.g. AkMainContent) and offset — required for sticky to work.
        stickyHeadersConfig: stickyHeaders ?? undefined,
        contentMode: contentMode
    });
    const nodeComponents = (0, $cozmU.useMemo)(()=>{
        if (SyncedBlockNodeComponent) return {
            syncBlock: SyncedBlockNodeComponent
        };
    }, [
        SyncedBlockNodeComponent
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Store the finalDocument ADF in context so it can be accessed by comment editor
    // and other components (e.g. SmartlinkAuthNudge) without prop threading.
    const { setPageAdf: setPageAdf } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $cozmU.useEffect)(()=>{
        if (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') {
            if (document) {
                const finalDocument = shimAdfUrls(document);
                setPageAdf(finalDocument);
            } else setPageAdf(undefined);
        }
    }, [
        appearance,
        document,
        setPageAdf,
        shimAdfUrls
    ]);
    if (!document) return null;
    const finalDocument = shimAdfUrls(document);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        timeZone: timeZone || tenantTimeZone || undefined,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        contentMode: contentMode,
        stickyHeaders: stickyHeaders,
        extensionHandlers: mergedExtensionHandlers,
        hideExtensionKeysWhilePending: (0, $6mKj3.expValEquals)('confluence_hide_pending_extension_fallback', 'isEnabled', true) ? $1af8a83cb114ff50$var$EXTENSION_KEYS_TO_HIDE_WHILE_PENDING : undefined,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders.providerFactory,
        portal: portal,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowAltTextOnImages: true,
        media: media,
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        mentionNodeDataProvider: resolvedMentionNodeDataProvider,
        onRendered: onRendererRendered,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: smartLinks,
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational,
        allowRendererContainerStyles: allowRendererContainerStyles,
        shouldDisplayExtensionAsInline: (0, $hMB4W.shouldDisplayExtensionAsInline),
        allowFixedColumnWidthOption: appearance === 'full-page' || appearance === 'full-width',
        ...nodeComponents && {
            nodeComponents: nodeComponents
        }
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgQGl.ContentRefetchHandler), {
        contentId: contentId,
        shouldRefetch: (0, $6mKj3.expVal)('task_cache_invalidation_fix', 'isEnabled', false) ? false : shouldRefetchContent,
        flushTaskStatusPatch: (0, $6mKj3.expVal)('task_cache_invalidation_fix', 'isEnabled', false) ? flushTaskStatusPatch : undefined
    }), pageMode && pageMode === (0, $cD1qu.PageMode).VIEW && !isEmbedded && (0, $6mKj3.expValEquals)('cc_smart_link_nudge_kill_switch', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26BUI.LazySmartlinkAuthNudge), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94rDp.EmbeddedForgeMacroHost), {
        document: document,
        flags: flags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9VON8.LazyViewPageAttachmentForgeActionsPortal), {
        contentId: contentId,
        contentType: contentType,
        isViewPage: pageMode === (0, $cD1qu.PageMode).VIEW,
        spaceKey: spaceKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, content);
});
module.exports["ANALYTICS_EVENT_SEVERITY_TRACKING"] = $1af8a83cb114ff50$export$3422b9c70e187e34;
module.exports["UNSUPPORTED_CONTENT_THRESHOLDS"] = $1af8a83cb114ff50$export$c02e908ea3c1fe52;
module.exports["ADFRendererComponent"] = $1af8a83cb114ff50$export$cec675c14d32c246;

});

parcelRegister("fgQGl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $83Z6R = parcelRequire("83Z6R");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $cLo2u = parcelRequire("cLo2u");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");


var $76bD2 = parcelRequire("76bD2");

const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete, flushTaskStatusPatch: flushTaskStatusPatch })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $f9opb.default) : (0, $jgc4t.default);
    const executeQuery = (0, $83Z6R.useLazyQueryPromiseInterop)(chooseContentUnifiedQuery, {
        fetchPolicy: 'network-only',
        __callerPackage__: "content-body"
    });
    // Store onRefetchComplete in a ref so the effect can always call the latest
    // version without needing it in the dependency array. This prevents callers
    // that pass an unstable function reference from causing an infinite refetch
    // loop when refetchImmediately is true.
    const onRefetchCompleteRef = (0, $cozmU.useRef)(onRefetchComplete);
    onRefetchCompleteRef.current = onRefetchComplete;
    const flushTaskStatusPatchRef = (0, $cozmU.useRef)(flushTaskStatusPatch);
    flushTaskStatusPatchRef.current = flushTaskStatusPatch;
    // Runs when the page is left (contentId changes or unmount). flushTaskStatusPatch drains the
    // patch context captured at toggle time; this component's own contentId can't be used because
    // the renderer instance is reused across SPA navigations and its contentId drifts to the next
    // page before this fires. Running on leave keeps the broadcasting cache write off the mounted
    // renderer.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const flush = flushTaskStatusPatchRef.current;
            if (!flush) return;
            const { taskStatusUpdates: taskStatusUpdates, ...context } = flush();
            if (taskStatusUpdates.length === 0) return;
            (0, $76bD2.patchTaskStatusInContentCache)({
                ...context,
                taskStatusUpdates: taskStatusUpdates
            });
        };
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                isSSR: isSSR,
                useNewContentTopper: true
            };
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    const queryResult = await executeQuery({
                        context: {
                            single: true
                        },
                        variables: queryVariable
                    });
                    versionNumber = queryResult.content?.nodes?.[0]?.version?.number;
                } catch  {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchCompleteRef.current && onRefetchCompleteRef.current(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    }, [
        shouldRefetch,
        executeQuery,
        contentId,
        spaceKey,
        isSSR,
        history,
        refetchImmediately
    ]);
    return null;
};
module.exports["ContentRefetchHandler"] = $96596a053dd4ef1e$export$d1bbac313eb9a2c1;

});

parcelRegister("76bD2", function(module, exports) {

var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");

const $ef083f8573fb553b$var$applyTaskStates = (root, states)=>{
    let changed = false;
    const stack = [
        root
    ];
    while(stack.length > 0){
        const node = stack.pop();
        if (!node || typeof node !== 'object') continue;
        const localId = node.type === 'taskItem' ? node.attrs?.localId : undefined;
        if (localId && states.has(localId)) {
            const nextState = states.get(localId);
            if (node.attrs && nextState && node.attrs.state !== nextState) {
                node.attrs.state = nextState;
                changed = true;
            }
        }
        if (Array.isArray(node.content)) stack.push(...node.content);
    }
    return changed;
};
const $ef083f8573fb553b$export$308244febf715de3 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, taskStatusUpdates: taskStatusUpdates })=>{
    if (!contentId || taskStatusUpdates.length === 0) return;
    const query = contentType === 'blogpost' ? (0, $f9opb.default) : (0, $jgc4t.default);
    const variables = {
        contentId: contentId,
        spaceKey: spaceKey,
        isSSR: false,
        useNewContentTopper: false,
        preloadLabels: false,
        includeAgentTrustReceiptData: false,
        fetchAgentSessionsMarker: false,
        agentSessionsPropertyKey: ''
    };
    try {
        const data = (0, $l1uFv.readQueryInterop)({
            query: query,
            variables: variables,
            __callerPackage__: "content-body"
        });
        const content = data?.content;
        const nodes = content?.nodes;
        const dynamic = nodes?.[0]?.body?.dynamic;
        if (!dynamic || dynamic.representation !== 'atlas_doc_format' || !dynamic.value) return;
        const adf = JSON.parse(dynamic.value);
        const states = new Map(taskStatusUpdates.map(({ localId: localId, state: state })=>[
                localId,
                state
            ]));
        if (!$ef083f8573fb553b$var$applyTaskStates(adf, states)) return;
        const patchedValue = JSON.stringify(adf);
        (0, $fEmGS.writeQueryInterop)({
            query: query,
            variables: variables,
            data: {
                ...data,
                content: {
                    ...content,
                    nodes: nodes.map((node, index)=>index === 0 && node ? {
                            ...node,
                            body: {
                                ...node.body,
                                dynamic: {
                                    ...node.body?.dynamic,
                                    value: patchedValue
                                }
                            }
                        } : node)
                }
            },
            __callerPackage__: "content-body"
        });
    } catch  {
    // Best-effort: a missing/unreadable cache entry must not throw while leaving the page.
    }
};
module.exports["patchTaskStatusInContentCache"] = $ef083f8573fb553b$export$308244febf715de3;

});

parcelRegister("b2eAY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hjUDQ = parcelRequire("hjUDQ");


var $5KWZf = parcelRequire("5KWZf");


var $dBD3L = parcelRequire("dBD3L");


var $KDPGa = parcelRequire("KDPGa");


var $bQmwQ = parcelRequire("bQmwQ");


var $gXR7h = parcelRequire("gXR7h");


var $jmjWc = parcelRequire("jmjWc");


var $9MYUp = parcelRequire("9MYUp");


var $cbvYp = parcelRequire("cbvYp");


const $044598a12ce14eec$export$b55cedbe49066c7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lL-x8",
    name: "CardsExtensionLoader",
    loader: async ()=>(await (parcelRequire("jLIuE"))).CardsExtension
});

const $044598a12ce14eec$var$PlatformSpotlightExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8j05",
    name: "PlatformSpotlightExtensionLoader",
    loader: async ()=>(await (parcelRequire("cAQRS"))).SpotlightExtension
});

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("k6dU9"))).CustomSearchExtension
});

const $044598a12ce14eec$var$LinksMenuLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "khj-w",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("cIgkf"))).LinksMenu
});

const $044598a12ce14eec$var$CarouselLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iP7CN",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("8tbzY"))).Carousel
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $dBD3L.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $gXR7h.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $KDPGa.SEARCH_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $dBD3L.CARDS_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$export$b55cedbe49066c7, {
                extensionNode: extension,
                contentId: contentId,
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $gXR7h.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$CarouselLoader, {
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$LinksMenuLoader, {
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$PlatformSpotlightExtensionLoader, {
                contentId: contentId,
                extensionNode: extension,
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE] = ()=>null;
        extensionHandlers[0, $KDPGa.SEARCH_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
    }
    return extensionHandlers;
};
module.exports["getRendererCustomSitesExtensionHandlers"] = $044598a12ce14eec$export$2a3fa2b29e6e4046;

});

parcelRegister("5KWZf", function(module, exports) {
const $23f879aa41f3f099$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $23f879aa41f3f099$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $23f879aa41f3f099$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $23f879aa41f3f099$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $23f879aa41f3f099$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $23f879aa41f3f099$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $23f879aa41f3f099$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $23f879aa41f3f099$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $23f879aa41f3f099$export$8e1a1e8b8109dbf3 = '#003172';
const $23f879aa41f3f099$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $23f879aa41f3f099$export$94d2a2331edd895d = '--hub-primary-text-color';
const $23f879aa41f3f099$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $23f879aa41f3f099$export$4c91e7265b76e3a1 = '32px';
const $23f879aa41f3f099$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $23f879aa41f3f099$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $23f879aa41f3f099$export$ea77880e3935182d = 'unknown';
const $23f879aa41f3f099$export$c7f012c6e67c4217 = 0;
module.exports["CARDS_EXTENSION_TYPE"] = $23f879aa41f3f099$export$81e5b59a1e176638;
module.exports["SPOTLIGHT_EXTENSION_TYPE"] = $23f879aa41f3f099$export$df3c2062a081a534;
module.exports["SECTION_EXTENSION_TYPE"] = $23f879aa41f3f099$export$4454075c4322ae47;
module.exports["RESOURCE_TILES_EXTENSION_TYPE"] = $23f879aa41f3f099$export$2dd5fc71941a6787;
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $23f879aa41f3f099$export$9fdf64a495514b4;
module.exports["CAROUSEL_EXTENSION_TYPE"] = $23f879aa41f3f099$export$514105ca7c79025d;
module.exports["SEARCH_EXTENSION_TYPE"] = $23f879aa41f3f099$export$cb2d1b0c753e69e6;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $23f879aa41f3f099$export$c14e692c91462ed4;
module.exports["HUB_PRIMARY_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$8161b1f4e2928fa0;
module.exports["HUB_PRIMARY_TEXT_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$94d2a2331edd895d;
module.exports["HUB_PRIMARY_LINK_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$64de52c9db8240f6;
module.exports["HUB_LOGO_HEIGHT"] = $23f879aa41f3f099$export$4c91e7265b76e3a1;
module.exports["HUB_LOGO_HEIGHT_LEGACY"] = $23f879aa41f3f099$export$d713f99e5e84a256;

});

parcelRegister("dBD3L", function(module, exports) {
const $e93ae61a08cdbc4f$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $e93ae61a08cdbc4f$export$8a4891a61ff91b00 = 'cards';
const $e93ae61a08cdbc4f$export$67bfcae6d68bb0bf = 'cardsExtension';
const $e93ae61a08cdbc4f$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $e93ae61a08cdbc4f$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $e93ae61a08cdbc4f$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $e93ae61a08cdbc4f$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $e93ae61a08cdbc4f$export$97dc3a9d9f5d9aa3 = 'dynamic-cards';
const $e93ae61a08cdbc4f$export$131b76b4d30d2b44 = '2';
const $e93ae61a08cdbc4f$export$a08b7507bedba276 = '3';
const $e93ae61a08cdbc4f$export$c87753a8bb0c4e75 = '4';
const $e93ae61a08cdbc4f$export$b84f9a7c097c895c = '5';
const $e93ae61a08cdbc4f$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];
module.exports["CARDS_EXTENSION_TYPE"] = $e93ae61a08cdbc4f$export$81e5b59a1e176638;
module.exports["CARDS_EXTENSION_KEY"] = $e93ae61a08cdbc4f$export$8a4891a61ff91b00;
module.exports["CARDS_EXTENSION_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$67bfcae6d68bb0bf;
module.exports["CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$7f17fab0aecb44ed;
module.exports["CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$6a35a50674becbae;
module.exports["CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$9bf56665bf6ea6ed;
module.exports["CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$cf23b6d2fd159502;
module.exports["DYNAMIC_CARDS_SEARCH_EXPERIENCE"] = $e93ae61a08cdbc4f$export$97dc3a9d9f5d9aa3;
module.exports["CARDS_EXTENSION_VERSION_5"] = $e93ae61a08cdbc4f$export$b84f9a7c097c895c;
module.exports["CARDS_IMAGES_V5"] = $e93ae61a08cdbc4f$export$5e905747d7497a1f;

});

parcelRegister("KDPGa", function(module, exports) {
const $7c2bfd2e70fd959d$export$e03f5e560317f88a = '1';
const $7c2bfd2e70fd959d$export$5e16975fb5214c6c = 'company-hub-search';
const $7c2bfd2e70fd959d$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $7c2bfd2e70fd959d$export$ec7b7d5be35b7dd3 = 'customSearchExtension';
module.exports["SEARCH_EXTENSION_VERSION_1"] = $7c2bfd2e70fd959d$export$e03f5e560317f88a;
module.exports["SEARCH_EXTENSION_KEY"] = $7c2bfd2e70fd959d$export$5e16975fb5214c6c;
module.exports["SEARCH_EXTENSION_TYPE"] = $7c2bfd2e70fd959d$export$cb2d1b0c753e69e6;
module.exports["CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE"] = $7c2bfd2e70fd959d$export$ec7b7d5be35b7dd3;

});

parcelRegister("bQmwQ", function(module, exports) {
const $6342bff3d053fae3$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $6342bff3d053fae3$export$ed5854f17099adbf = 'linksMenuExtension';
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $6342bff3d053fae3$export$9fdf64a495514b4;
module.exports["LINKS_MENU_EXTENSION_ANALYTIC_SOURCE"] = $6342bff3d053fae3$export$ed5854f17099adbf;

});

parcelRegister("gXR7h", function(module, exports) {
const $e97883ecdb0f2de9$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $e97883ecdb0f2de9$export$6c8179fa243b4399 = 'carousel';
const $e97883ecdb0f2de9$export$ca14f22a239c4ae9 = 'carouselExtension';
const $e97883ecdb0f2de9$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $e97883ecdb0f2de9$export$93995a2609cff38d = 8;
const $e97883ecdb0f2de9$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $e97883ecdb0f2de9$export$9575b4f5d97a1c29 = '1';
const $e97883ecdb0f2de9$export$b429752dfe934bea = '2';
const $e97883ecdb0f2de9$export$c5c6e75ceae0cc22 = 10;
module.exports["carouselExtensionType"] = $e97883ecdb0f2de9$export$a06ac4f1777262dc;
module.exports["carouselExtensionKey"] = $e97883ecdb0f2de9$export$6c8179fa243b4399;
module.exports["carouselContentAnalyticSource"] = $e97883ecdb0f2de9$export$ca14f22a239c4ae9;
module.exports["carouselConfigAnalyticSource"] = $e97883ecdb0f2de9$export$4cb671946a80c52e;
module.exports["AUTOPLAY_SECONDS"] = $e97883ecdb0f2de9$export$93995a2609cff38d;
module.exports["ARIA_CONTROLS_PREFIX"] = $e97883ecdb0f2de9$export$3a86d0fc7eb402f4;
module.exports["CAROUSEL_VERSION_2"] = $e97883ecdb0f2de9$export$b429752dfe934bea;
module.exports["FRAMES_LIMIT_V2"] = $e97883ecdb0f2de9$export$c5c6e75ceae0cc22;

});

parcelRegister("9MYUp", function(module, exports) {
const $2e285551d02f5ba2$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $2e285551d02f5ba2$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $2e285551d02f5ba2$export$c14e692c91462ed4;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY"] = $2e285551d02f5ba2$export$ca3a94184e0fbd97;

});

parcelRegister("cbvYp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");


var $4IoVL = parcelRequire("4IoVL");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");


var $6M71K = parcelRequire("6M71K");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $lOeVN = parcelRequire("lOeVN");


var $bAIqi = parcelRequire("bAIqi");


var $bflGB = parcelRequire("bflGB");



var $hl1Kw = parcelRequire("hl1Kw");


var $cEgMD = parcelRequire("cEgMD");


var $78QFu = parcelRequire("78QFu");


var $ep3mz = parcelRequire("ep3mz");


var $2YtTU = parcelRequire("2YtTU");


var $afE6L = parcelRequire("afE6L");


var $biMIt = parcelRequire("biMIt");


var $fuwTw = parcelRequire("fuwTw");

const $73ff39965b133879$var$useFeedbackCollectorWrapper = ({ source: source, type: type })=>{
    return (0, $lOeVN.useFeedbackCollector)({
        source: source,
        type: type
    });
};
const $73ff39965b133879$var$useSegmentationTargetGroupsWrapper = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds = [] })=>{
    return (0, $fuwTw.useSegmentationTargetGroups)({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds
    });
};
const $73ff39965b133879$var$ShortcutListenerWrapper = ({ accelerator: accelerator, listener: listener })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        listener: listener
    });
};
const $73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper = ({ feature: feature })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bAIqi.ExtensionConfigUpsellLoader), {
        feature: feature
    });
};
const $73ff39965b133879$var$submitError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
};
const $73ff39965b133879$var$SmartCardProvider = ({ children: children })=>{
    return(// disable preview panel functionality for cards
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        isPreviewPanelAvailable: (_ari)=>false
    }, children));
};
const $73ff39965b133879$export$ae511a2e03f02bcc = ({ contentId: contentId, fileId: fileId })=>{
    // When experiment is enabled, store in format: {contentId}/{fileId}
    // This allows us to track which page the image was originally uploaded to
    // When copy-pasting to another page, useMediaConfig will extract the original contentId
    // Check if the fileId already contains the contentId prefix (e.g., from linked page header)
    // If it already has a "/", it's in format {contentId}/{fileId} and we don't add another prefix
    if ((0, $6mKj3.expValEquals)('ccpi_broken_upload_images_for_confluence', 'isEnabled', true)) return fileId.includes('/') ? fileId : `${contentId}/${fileId}`;
    return fileId;
};
const $73ff39965b133879$export$52286abe2bf4f236 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $cozmU.useCallback)(({ analyticsSource: analyticsSource })=>{
        experienceTracker.start({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $cozmU.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$50a2d523eb80eb6f = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $cozmU.useCallback)(({ analyticsSource: analyticsSource, confluencePageId: confluencePageId })=>{
        experienceTracker.start({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            attributes: {
                source: analyticsSource,
                contentId: confluencePageId
            }
        });
    }, [
        experienceTracker
    ]);
    const abort = (0, $cozmU.useCallback)(({ reason: reason })=>{
        experienceTracker.abort({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $cozmU.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        abort: abort,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$4bd687f80e42155a = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    // If it's not a stored cover image, we return original contentId & imageSrc
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $73ff39965b133879$export$7f746b47c356effa = ({ contentId: contentId, imageSrc: imageSrc })=>{
    const [mediaConfig, setMediaConfig] = (0, $cozmU.useState)(null);
    // When imageSrc is a stored cover image, it comes in format '{contentId}/{fileId}'
    // We need to split the string to get the collectionId and fileId
    const [collectionId, fileId] = $73ff39965b133879$export$4bd687f80e42155a(contentId, imageSrc);
    (0, $cozmU.useEffect)(()=>{
        async function createMediaConfig() {
            if (!(0, $4IoVL.createRendererMediaProvider)) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider,
                fileId: fileId
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        fileId
    ]);
    return mediaConfig;
};
const $73ff39965b133879$export$9a7b37d3055a69a6 = ({ mode: mode, extensionNode: extensionNode, contentId: contentId = '', children: children })=>{
    const mediaUploadExperienceTracker = $73ff39965b133879$export$52286abe2bf4f236();
    const aiDescriptionExperienceTracker = $73ff39965b133879$export$50a2d523eb80eb6f();
    const sessionData = (0, $bQm3c.useSessionData)();
    const { cloudId: cloudId, displayName: displayName, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId, userId: userId } = sessionData || {};
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isTargetAudience: isTargetAudience } = (0, $cozmU.useContext)((0, $biMIt.AudienceSegmentationContext));
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const ConfigUpsellScreen = (0, $cozmU.useMemo)(()=>shouldShowPremiumUpsell ? ({ feature: feature })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper, {
                feature: feature
            }) : undefined, [
        shouldShowPremiumUpsell
    ]);
    const experienceStartComponent = (0, $cozmU.useCallback)(()=>{
        if (!extensionNode) return null;
        const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
        const experienceName = (0, $5kjCz.getExperienceName)(mode, extensionNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            attributes: macroAttributes,
            extensionKey: extensionNode.extensionKey,
            contentId: contentId,
            mode: mode,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceSuccessComponent = (0, $cozmU.useCallback)(()=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceStopComponent = (0, $cozmU.useCallback)(({ error: error })=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hUS75.MacroExperienceStop), {
            error: error,
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const isSSRProductInDarkMode = (0, $cozmU.useMemo)(()=>{
        return undefined;
    }, []);
    const errorBoundaryComponent = (0, $cozmU.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            }, children), []);
    const errorDisplayComponent = (0, $cozmU.useMemo)(()=>({ error: error, childrenComponents: childrenComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, childrenComponents), []);
    const useAnalyticsActions = (0, $cozmU.useMemo)(()=>({
            useLinkAnalyticActions: $afE6L.useLinkAnalyticActions
        }), []);
    const value = (0, $cozmU.useMemo)(()=>({
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent,
            experienceStopComponent: experienceStopComponent,
            cloudId: cloudId,
            searchConfigProvider: {
                peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
                advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
                searchSessionId: searchSessionId || ''
            },
            displayName: displayName || '',
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            orgId: orgId || '',
            userId: userId || '',
            errorBoundaryComponent: errorBoundaryComponent,
            errorDisplayComponent: errorDisplayComponent,
            submitError: $73ff39965b133879$var$submitError,
            markErrorAsHandled: $7Sm4c.markErrorAsHandled,
            useMediaConfig: $73ff39965b133879$export$7f746b47c356effa,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            mediaUploadExperienceTracker: mediaUploadExperienceTracker,
            transformUploadedImageId: $73ff39965b133879$export$ae511a2e03f02bcc,
            aiDescriptionExperienceTracker: aiDescriptionExperienceTracker,
            useFeedbackCollector: $73ff39965b133879$var$useFeedbackCollectorWrapper,
            shortcutListener: $73ff39965b133879$var$ShortcutListenerWrapper,
            shouldShowPremiumUpsell: shouldShowPremiumUpsell,
            ConfigUpsellScreen: ConfigUpsellScreen,
            useSegmentationTargetGroups: $73ff39965b133879$var$useSegmentationTargetGroupsWrapper,
            isSSRProductInDarkMode: isSSRProductInDarkMode,
            analyticsContext: {
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            useAnalyticsActions: useAnalyticsActions,
            isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
            isTargetAudience: isTargetAudience,
            smartCardProviderComponent: $73ff39965b133879$var$SmartCardProvider,
            showConfigPreambleSupportLink: true,
            enableTargeting: true,
            enableUnifiedSearchFeatures: true,
            enableSmartCardsFields: true
        }), [
        experienceSuccessComponent,
        experienceStopComponent,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        orgId,
        userId,
        searchSessionId,
        shouldShowPremiumUpsell,
        ConfigUpsellScreen,
        isSSRProductInDarkMode,
        errorBoundaryComponent,
        errorDisplayComponent,
        experienceStartComponent,
        mediaUploadExperienceTracker,
        aiDescriptionExperienceTracker,
        useAnalyticsActions,
        spaceKey,
        isTargetAudience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfM7x.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $73ff39965b133879$export$443fd6903ad182a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73ff39965b133879$export$9a7b37d3055a69a6, props, children);
module.exports["ConfluenceDependenciesProvider"] = $73ff39965b133879$export$443fd6903ad182a1;

});

parcelRegister("bAIqi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c72132c26b9ae6$export$349c99e57ed161b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "at4mJ",
    name: "ExtensionConfigUpsellLoader",
    loader: async ()=>(await (parcelRequire("5PWRC"))).ExtensionConfigUpsell
});

const $c1c72132c26b9ae6$export$25389a114c9b393f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rxN2C",
    name: "ExtensionInsertUpsellLoader",
    loader: async ()=>(await (parcelRequire("iojMH"))).ExtensionInsertUpsell
});
module.exports["ExtensionConfigUpsellLoader"] = $c1c72132c26b9ae6$export$349c99e57ed161b9;
module.exports["ExtensionInsertUpsellLoader"] = $c1c72132c26b9ae6$export$25389a114c9b393f;

});

parcelRegister("5PWRC", function(module, exports) {

let $43ff604fcff19087$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $43ff604fcff19087$var$load("6XCf4"),
    $43ff604fcff19087$var$load("ebvEF"),
    $43ff604fcff19087$var$load("aEiTV"),
    $43ff604fcff19087$var$load("1qlDN"),
    $43ff604fcff19087$var$load("1yVM6"),
    $43ff604fcff19087$var$load("9wTrW")
]).then(()=>parcelRequire('d1uaq'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("iojMH", function(module, exports) {

let $d639d0af9e617a97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d639d0af9e617a97$var$load("6XCf4"),
    $d639d0af9e617a97$var$load("ebvEF"),
    $d639d0af9e617a97$var$load("aEiTV"),
    $d639d0af9e617a97$var$load("1qlDN"),
    $d639d0af9e617a97$var$load("1yVM6"),
    $d639d0af9e617a97$var$load("5HTv6")
]).then(()=>parcelRequire('f4NfX'));

});

parcelRegister("2YtTU", function(module, exports) {

var $9ff1X = parcelRequire("9ff1X");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $jMyy4 = parcelRequire("jMyy4");

const $50d2dd6da149924b$export$31a131ac01af5546 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const canSkipEntitlementCheck = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $9ff1X.default), {
        skip: canSkipEntitlementCheck,
        __callerPackage__: "custom-sites-extensions"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
module.exports["usePremiumGate"] = $50d2dd6da149924b$export$31a131ac01af5546;

});

parcelRegister("9ff1X", function(module, exports) {
/**
 * @generated SignedSource<<8bb9bdb80921f64e532e9a0a860836ba>>
 * @relayHash b3b58abba516a7066e43fee230bb62d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6
const $ce65a234c274b394$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PremiumExtensionsFeature",
                    "kind": "LinkedField",
                    "name": "premiumExtensions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "b3b58abba516a7066e43fee230bb62d7",
            "id": "dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6",
            "metadata": {},
            "name": "usePremiumGatePremiumGateQuery",
            "operationKind": "query",
            "text": "query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}"
        }
    };
}();
$ce65a234c274b394$var$node.hash = "53ba2ea71d0cb2a819a38d3bb3e49b44";
var $ce65a234c274b394$export$2e2bcd8739ae039 = $ce65a234c274b394$var$node;
module.exports["default"] = $ce65a234c274b394$export$2e2bcd8739ae039;

});

parcelRegister("afE6L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $4yccB = parcelRequire("4yccB");


var $5Gcps = parcelRequire("5Gcps");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");

const $4305591bcf0ed0e4$export$bd1b893a71ee8dab = (link)=>{
    const [analyticFields, setAnalyticFields] = (0, $cozmU.useState)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            const client = new (0, $4yccB.default)();
            try {
                const queriedMetadata = !!link && await client.fetchData(link);
                if (!queriedMetadata || !queriedMetadata.meta) return;
                const { containerId: initialContainerId, tenantId: initialTenantId, objectId: initialObjectId } = queriedMetadata.meta || {};
                if (!initialObjectId) return;
                const newObjectId = await (0, $5Gcps.getClickAndViewEventObjectIdFromLinkData)(initialObjectId, initialContainerId);
                setAnalyticFields({
                    containerId: initialContainerId,
                    tenantId: initialTenantId,
                    objectId: newObjectId
                });
            } catch (error) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        fetchData();
    }, [
        link
    ]);
    const { tenantId: tenantId, objectId: objectId } = analyticFields || {};
    const handleClick = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateClickEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    const handleView = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateViewEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    return {
        handleClick: analyticFields ? handleClick : undefined,
        handleView: analyticFields ? handleView : undefined
    };
};
module.exports["useLinkAnalyticActions"] = $4305591bcf0ed0e4$export$bd1b893a71ee8dab;

});

parcelRegister("5Gcps", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $9KwEc = parcelRequire("9KwEc");

const $9f3924c176ad2a57$export$2dd23eaa621322c4 = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: 'page',
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: 'page',
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$e25d369331b443dc = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'clicked',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: objectId ? 'page' : null,
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: objectId ? 'page' : null,
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$95c55278d4aca494 = async (objectId, destinationContainerId)=>{
    if (destinationContainerId === objectId) {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $9KwEc.SpaceMetadataQuery),
            variables: {
                id: destinationContainerId
            },
            __callerPackage__: "analytics"
        });
        const homepageId = data?.spaces?.nodes?.[0]?.homepage?.id;
        if (!homepageId) return;
        return homepageId;
    }
    return objectId;
};
module.exports["generateViewEventPayload"] = $9f3924c176ad2a57$export$2dd23eaa621322c4;
module.exports["generateClickEventPayload"] = $9f3924c176ad2a57$export$e25d369331b443dc;
module.exports["getClickAndViewEventObjectIdFromLinkData"] = $9f3924c176ad2a57$export$95c55278d4aca494;

});

parcelRegister("9KwEc", function(module, exports) {

var $hsdxj = parcelRequire("hsdxj");

const $e798eb82c10075ec$export$10df301dbc20c6db = (0, $hsdxj.default);
module.exports["SpaceMetadataQuery"] = $e798eb82c10075ec$export$10df301dbc20c6db;

});

parcelRegister("hsdxj", function(module, exports) {
/**
 * @generated SignedSource<<4ec0d41eabd26d29b4ef59d463a9ba52>>
 * @relayHash 2ce4acba36ec591640edbadf9a4c0da1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a
const $c81d24d8a5f7522b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "2ce4acba36ec591640edbadf9a4c0da1",
            "id": "45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a",
            "metadata": {},
            "name": "SpaceMetadataQuery",
            "operationKind": "query",
            "text": "query SpaceMetadataQuery($id:Long!){spaces(spaceId:$id){nodes{homepage{id},id}}}"
        }
    };
}();
$c81d24d8a5f7522b$var$node.hash = "ebea840491a8ee540fbdcc7340dcbf80";
var $c81d24d8a5f7522b$export$2e2bcd8739ae039 = $c81d24d8a5f7522b$var$node;
module.exports["default"] = $c81d24d8a5f7522b$export$2e2bcd8739ae039;

});

parcelRegister("biMIt", function(module, exports) {

var $jtfsl = parcelRequire("jtfsl");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery = (0, $jtfsl.default);
const $ab43be195aa7029f$export$f8421e3bf566787d = 'accessible-to-anyone';
const $ab43be195aa7029f$export$6fb8438eed1d64ed = /*#__PURE__*/ (0, $cozmU.createContext)({
    isCompanyHub: false,
    currentAudienceGroupIds: [],
    setCurrentAudienceGroupIds: ()=>{},
    isTargetAudience: ()=>true,
    isSegmentationApplied: false,
    setIsSegmentationApplied: ()=>{}
});
const $ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal = ({ children: children, isCompanyHub: isCompanyHub, initialAudienceGroupIds: initialAudienceGroupIds = [], initialSegmentationApplied: initialSegmentationApplied = false, shouldFetchUserGroups: shouldFetchUserGroups = false })=>{
    const [currentAudienceGroupIds, setCurrentAudienceGroupIds] = (0, $cozmU.useState)(initialAudienceGroupIds);
    const [isSegmentationApplied, setIsSegmentationApplied] = (0, $cozmU.useState)(initialSegmentationApplied);
    const isTargetAudience = (0, $cozmU.useCallback)((targetGroupIds)=>{
        if (!isCompanyHub || // if we are outside of company hub, no filtering
        targetGroupIds === undefined // if no target groups are provided, no filtering
        ) return true;
        setIsSegmentationApplied(true);
        const audienceGroupIdsSet = new Set(currentAudienceGroupIds);
        if (audienceGroupIdsSet.has($ab43be195aa7029f$export$f8421e3bf566787d)) return false;
        return targetGroupIds?.some((allowedGroup)=>audienceGroupIdsSet.has(allowedGroup));
    }, [
        currentAudienceGroupIds,
        isCompanyHub
    ]);
    const audienceSegmentationContextValue = (0, $cozmU.useMemo)(()=>({
            currentAudienceGroupIds: currentAudienceGroupIds,
            setCurrentAudienceGroupIds: setCurrentAudienceGroupIds,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isSegmentationApplied: isSegmentationApplied,
            setIsSegmentationApplied: setIsSegmentationApplied
        }), [
        currentAudienceGroupIds,
        isCompanyHub,
        isTargetAudience,
        isSegmentationApplied
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { error: queryError, loading: queryLoading } = (0, $jMyy4.useQueryInterop)($ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery, {
        skip: !shouldFetchUserGroups || !isCompanyHub,
        variables: {
            accountId: userId
        },
        onCompleted: (data)=>{
            const userGroupIds = data?.user?.confluence?.groupsWithId?.map((result)=>result?.id).filter((id)=>!!id) ?? [];
            // onCompleted shouldn't be called if we skip the query but this is to ensure
            // the state doesn't get set when the fixture mock gives this query the default value
            shouldFetchUserGroups && setCurrentAudienceGroupIds(userGroupIds);
        },
        __callerPackage__: "custom-sites-extensions"
    });
    const errorDisplay = (0, $cozmU.useMemo)(()=>{
        if (queryError && !queryLoading) {
            if ((0, $1uFM6.isUnauthorizedError)(queryError)) (0, $7Sm4c.markErrorAsHandled)(queryError);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryError
            });
        }
        return null;
    }, [
        queryError,
        queryLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab43be195aa7029f$export$6fb8438eed1d64ed.Provider, {
        value: audienceSegmentationContextValue
    }, errorDisplay, children);
};
const $ab43be195aa7029f$export$23b23ee9c5e80f4e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
})($ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal);
module.exports["COMMON_VIEW_ID"] = $ab43be195aa7029f$export$f8421e3bf566787d;
module.exports["AudienceSegmentationContext"] = $ab43be195aa7029f$export$6fb8438eed1d64ed;
module.exports["AudienceSegmentationContextProvider"] = $ab43be195aa7029f$export$23b23ee9c5e80f4e;

});

parcelRegister("fuwTw", function(module, exports) {

var $gJisj = parcelRequire("gJisj");


var $cozmU = parcelRequire("cozmU");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $a453bfc5db2076e7$export$df3f3e4ed2d81d7 = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $gJisj.default), {
        variables: {
            after: nextCursor
        },
        skip: initialGroupIds.length === 0,
        __callerPackage__: "custom-sites-extensions"
    });
    let errorComponent = undefined;
    if (error && !loading) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    return {
        data: data,
        loading: loading,
        errorComponent: errorComponent
    };
};
module.exports["useSegmentationTargetGroups"] = $a453bfc5db2076e7$export$df3f3e4ed2d81d7;

});

parcelRegister("gJisj", function(module, exports) {
/**
 * @generated SignedSource<<5d9f0f9b4d004db5c39c281d1073c821>>
 * @relayHash aea879681eafb8d8dc2e8d788d24714d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406
const $53bd2fb7fcb3ebe9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 25,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "groups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "aea879681eafb8d8dc2e8d788d24714d",
            "id": "ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406",
            "metadata": {},
            "name": "useSegmentationTargetGroupsQuery",
            "operationKind": "query",
            "text": "query useSegmentationTargetGroupsQuery($after:String,$first:Int=25){groups(after:$after,first:$first){nodes{id,name},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$53bd2fb7fcb3ebe9$var$node.hash = "b1d866007d469142c79544536019c0ef";
var $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039 = $53bd2fb7fcb3ebe9$var$node;
module.exports["default"] = $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039;

});

parcelRegister("jLIuE", function(module, exports) {

let $e644eb8cb8ef3f18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e644eb8cb8ef3f18$var$load("g38mE"),
    $e644eb8cb8ef3f18$var$load("aaiTv"),
    $e644eb8cb8ef3f18$var$load("bEqGC"),
    $e644eb8cb8ef3f18$var$load("3CHco"),
    $e644eb8cb8ef3f18$var$load("dYH04"),
    $e644eb8cb8ef3f18$var$load("gkVge"),
    $e644eb8cb8ef3f18$var$load("hUbK8"),
    $e644eb8cb8ef3f18$var$load("7H1j2"),
    $e644eb8cb8ef3f18$var$load("25adb"),
    $e644eb8cb8ef3f18$var$load("lxkQl"),
    $e644eb8cb8ef3f18$var$load("dgmjH"),
    $e644eb8cb8ef3f18$var$load("6UOty"),
    $e644eb8cb8ef3f18$var$load("3FSsi"),
    $e644eb8cb8ef3f18$var$load("dMVmv"),
    $e644eb8cb8ef3f18$var$load("1xRFJ"),
    $e644eb8cb8ef3f18$var$load("bxj2D"),
    $e644eb8cb8ef3f18$var$load("eFLq9"),
    $e644eb8cb8ef3f18$var$load("b0ARW"),
    $e644eb8cb8ef3f18$var$load("1Gr4q"),
    $e644eb8cb8ef3f18$var$load("VXbA1"),
    $e644eb8cb8ef3f18$var$load("2PVCX"),
    $e644eb8cb8ef3f18$var$load("eUsnQ"),
    $e644eb8cb8ef3f18$var$load("6C7Vr"),
    $e644eb8cb8ef3f18$var$load("ariuh"),
    $e644eb8cb8ef3f18$var$load("4B1fg"),
    $e644eb8cb8ef3f18$var$load("eHgxr"),
    $e644eb8cb8ef3f18$var$load("Wowvf"),
    $e644eb8cb8ef3f18$var$load("7EorR"),
    $e644eb8cb8ef3f18$var$load("hhss7"),
    $e644eb8cb8ef3f18$var$load("cvcNg"),
    $e644eb8cb8ef3f18$var$load("jXM1T"),
    $e644eb8cb8ef3f18$var$load("gNPMO"),
    $e644eb8cb8ef3f18$var$load("jfSwd"),
    $e644eb8cb8ef3f18$var$load("1dC87"),
    $e644eb8cb8ef3f18$var$load("3fvOY"),
    $e644eb8cb8ef3f18$var$load("42SV3"),
    $e644eb8cb8ef3f18$var$load("1VvO7"),
    $e644eb8cb8ef3f18$var$load("g8Cky"),
    $e644eb8cb8ef3f18$var$load("db7T5"),
    $e644eb8cb8ef3f18$var$load("cIf37"),
    $e644eb8cb8ef3f18$var$load("asveJ"),
    $e644eb8cb8ef3f18$var$load("5He1y"),
    $e644eb8cb8ef3f18$var$load("4zz48"),
    $e644eb8cb8ef3f18$var$load("39XCn"),
    $e644eb8cb8ef3f18$var$load("jw3lv"),
    $e644eb8cb8ef3f18$var$load("7rqWx"),
    $e644eb8cb8ef3f18$var$load("3Cky6"),
    $e644eb8cb8ef3f18$var$load("kG5Ju"),
    $e644eb8cb8ef3f18$var$load("il8bj"),
    $e644eb8cb8ef3f18$var$load("6wr18"),
    $e644eb8cb8ef3f18$var$load("ffEVr"),
    $e644eb8cb8ef3f18$var$load("aFLSJ"),
    $e644eb8cb8ef3f18$var$load("6bjEk"),
    $e644eb8cb8ef3f18$var$load("iYZAq"),
    $e644eb8cb8ef3f18$var$load("bru8i")
]).then(()=>parcelRequire('eKNXi'));

});

parcelRegister("cAQRS", function(module, exports) {

let $92b1db4ac96b14ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $92b1db4ac96b14ee$var$load("lxkQl"),
    $92b1db4ac96b14ee$var$load("g38mE"),
    $92b1db4ac96b14ee$var$load("3CHco"),
    $92b1db4ac96b14ee$var$load("dYH04"),
    $92b1db4ac96b14ee$var$load("bjgFk"),
    $92b1db4ac96b14ee$var$load("iEsP0"),
    $92b1db4ac96b14ee$var$load("2o2NN"),
    $92b1db4ac96b14ee$var$load("hUbK8"),
    $92b1db4ac96b14ee$var$load("fqJr7"),
    $92b1db4ac96b14ee$var$load("7H1j2"),
    $92b1db4ac96b14ee$var$load("25adb"),
    $92b1db4ac96b14ee$var$load("3FSsi"),
    $92b1db4ac96b14ee$var$load("dMVmv"),
    $92b1db4ac96b14ee$var$load("1Gr4q"),
    $92b1db4ac96b14ee$var$load("VXbA1"),
    $92b1db4ac96b14ee$var$load("2PVCX"),
    $92b1db4ac96b14ee$var$load("4B1fg"),
    $92b1db4ac96b14ee$var$load("1VvO7"),
    $92b1db4ac96b14ee$var$load("g8Cky"),
    $92b1db4ac96b14ee$var$load("db7T5"),
    $92b1db4ac96b14ee$var$load("cIf37"),
    $92b1db4ac96b14ee$var$load("asveJ"),
    $92b1db4ac96b14ee$var$load("eHgxr"),
    $92b1db4ac96b14ee$var$load("Wowvf"),
    $92b1db4ac96b14ee$var$load("7EorR"),
    $92b1db4ac96b14ee$var$load("hhss7"),
    $92b1db4ac96b14ee$var$load("5He1y"),
    $92b1db4ac96b14ee$var$load("cvcNg"),
    $92b1db4ac96b14ee$var$load("4zz48"),
    $92b1db4ac96b14ee$var$load("39XCn"),
    $92b1db4ac96b14ee$var$load("jw3lv"),
    $92b1db4ac96b14ee$var$load("7rqWx"),
    $92b1db4ac96b14ee$var$load("3Cky6"),
    $92b1db4ac96b14ee$var$load("kG5Ju"),
    $92b1db4ac96b14ee$var$load("il8bj"),
    $92b1db4ac96b14ee$var$load("6wr18"),
    $92b1db4ac96b14ee$var$load("aFLSJ"),
    $92b1db4ac96b14ee$var$load("ffEVr"),
    $92b1db4ac96b14ee$var$load("6bjEk"),
    $92b1db4ac96b14ee$var$load("jfSwd"),
    $92b1db4ac96b14ee$var$load("42SV3"),
    $92b1db4ac96b14ee$var$load("96rwC")
]).then(()=>parcelRequire('bZm0X'));

});

parcelRegister("k6dU9", function(module, exports) {

let $ea1f2760498ad6b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ea1f2760498ad6b3$var$load("gkVge"),
    $ea1f2760498ad6b3$var$load("cvcNg"),
    $ea1f2760498ad6b3$var$load("6wr18"),
    $ea1f2760498ad6b3$var$load("9w623"),
    $ea1f2760498ad6b3$var$load("gNPMO"),
    $ea1f2760498ad6b3$var$load("3FSsi"),
    $ea1f2760498ad6b3$var$load("dMVmv"),
    $ea1f2760498ad6b3$var$load("1aqfs"),
    $ea1f2760498ad6b3$var$load("1xRFJ"),
    $ea1f2760498ad6b3$var$load("eFLq9"),
    $ea1f2760498ad6b3$var$load("7G12e"),
    $ea1f2760498ad6b3$var$load("2PVCX"),
    $ea1f2760498ad6b3$var$load("lgIhe"),
    $ea1f2760498ad6b3$var$load("eUsnQ"),
    $ea1f2760498ad6b3$var$load("6C7Vr"),
    $ea1f2760498ad6b3$var$load("eHgxr"),
    $ea1f2760498ad6b3$var$load("Wowvf"),
    $ea1f2760498ad6b3$var$load("hhss7"),
    $ea1f2760498ad6b3$var$load("ffEVr"),
    $ea1f2760498ad6b3$var$load("4lu2a")
]).then(()=>parcelRequire('42CfU'));

});

parcelRegister("cIgkf", function(module, exports) {

let $941641ff667613e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $941641ff667613e5$var$load("hUbK8"),
    $941641ff667613e5$var$load("eOFeQ"),
    $941641ff667613e5$var$load("25adb"),
    $941641ff667613e5$var$load("3FSsi"),
    $941641ff667613e5$var$load("dMVmv"),
    $941641ff667613e5$var$load("6vAHn"),
    $941641ff667613e5$var$load("do5z1"),
    $941641ff667613e5$var$load("1Gr4q"),
    $941641ff667613e5$var$load("hS8gF"),
    $941641ff667613e5$var$load("7G12e"),
    $941641ff667613e5$var$load("g8A75"),
    $941641ff667613e5$var$load("2PVCX"),
    $941641ff667613e5$var$load("hhss7"),
    $941641ff667613e5$var$load("5pK3l"),
    $941641ff667613e5$var$load("4B1fg"),
    $941641ff667613e5$var$load("eHgxr"),
    $941641ff667613e5$var$load("Wowvf"),
    $941641ff667613e5$var$load("7EorR"),
    $941641ff667613e5$var$load("cvcNg"),
    $941641ff667613e5$var$load("iZR3N"),
    $941641ff667613e5$var$load("jXM1T"),
    $941641ff667613e5$var$load("aIze1"),
    $941641ff667613e5$var$load("6wr18"),
    $941641ff667613e5$var$load("ffEVr"),
    $941641ff667613e5$var$load("4N1MY"),
    $941641ff667613e5$var$load("c70Sh")
]).then(()=>parcelRequire('cn3r4'));

});

parcelRegister("8tbzY", function(module, exports) {

let $62aa0390de81ab11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $62aa0390de81ab11$var$load("g38mE"),
    $62aa0390de81ab11$var$load("aaiTv"),
    $62aa0390de81ab11$var$load("bEqGC"),
    $62aa0390de81ab11$var$load("3CHco"),
    $62aa0390de81ab11$var$load("dYH04"),
    $62aa0390de81ab11$var$load("hUbK8"),
    $62aa0390de81ab11$var$load("aQPuI"),
    $62aa0390de81ab11$var$load("7i9SF"),
    $62aa0390de81ab11$var$load("7H1j2"),
    $62aa0390de81ab11$var$load("25adb"),
    $62aa0390de81ab11$var$load("lxkQl"),
    $62aa0390de81ab11$var$load("jfSwd"),
    $62aa0390de81ab11$var$load("1dC87"),
    $62aa0390de81ab11$var$load("6UOty"),
    $62aa0390de81ab11$var$load("3fvOY"),
    $62aa0390de81ab11$var$load("3FSsi"),
    $62aa0390de81ab11$var$load("dMVmv"),
    $62aa0390de81ab11$var$load("bxj2D"),
    $62aa0390de81ab11$var$load("1Gr4q"),
    $62aa0390de81ab11$var$load("hS8gF"),
    $62aa0390de81ab11$var$load("7G12e"),
    $62aa0390de81ab11$var$load("g8A75"),
    $62aa0390de81ab11$var$load("VXbA1"),
    $62aa0390de81ab11$var$load("2PVCX"),
    $62aa0390de81ab11$var$load("jgaRb"),
    $62aa0390de81ab11$var$load("42SV3"),
    $62aa0390de81ab11$var$load("4B1fg"),
    $62aa0390de81ab11$var$load("1VvO7"),
    $62aa0390de81ab11$var$load("g8Cky"),
    $62aa0390de81ab11$var$load("db7T5"),
    $62aa0390de81ab11$var$load("cIf37"),
    $62aa0390de81ab11$var$load("asveJ"),
    $62aa0390de81ab11$var$load("6fJCf"),
    $62aa0390de81ab11$var$load("eHgxr"),
    $62aa0390de81ab11$var$load("Wowvf"),
    $62aa0390de81ab11$var$load("7EorR"),
    $62aa0390de81ab11$var$load("hhss7"),
    $62aa0390de81ab11$var$load("5He1y"),
    $62aa0390de81ab11$var$load("cvcNg"),
    $62aa0390de81ab11$var$load("iZR3N"),
    $62aa0390de81ab11$var$load("4zz48"),
    $62aa0390de81ab11$var$load("jXM1T"),
    $62aa0390de81ab11$var$load("39XCn"),
    $62aa0390de81ab11$var$load("jw3lv"),
    $62aa0390de81ab11$var$load("7rqWx"),
    $62aa0390de81ab11$var$load("aIze1"),
    $62aa0390de81ab11$var$load("3Cky6"),
    $62aa0390de81ab11$var$load("kG5Ju"),
    $62aa0390de81ab11$var$load("il8bj"),
    $62aa0390de81ab11$var$load("4N1MY"),
    $62aa0390de81ab11$var$load("6wr18"),
    $62aa0390de81ab11$var$load("aFLSJ"),
    $62aa0390de81ab11$var$load("ffEVr"),
    $62aa0390de81ab11$var$load("6bjEk"),
    $62aa0390de81ab11$var$load("bQzWg")
]).then(()=>parcelRequire('2zngr'));

});

parcelRegister("7BsWq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d70acb7f5d54408a$export$9143d6ac64592241 = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $cozmU.useMemo)(()=>({
            /**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */ 'lp-link-picker': true,
            'table-with-fixed-column-widths-option': true
        }), []);
};
module.exports["useEditorFeatureFlags"] = $d70acb7f5d54408a$export$9143d6ac64592241;

});

parcelRegister("brsfB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $b6fxF = parcelRequire("b6fxF");


var $6mKj3 = parcelRequire("6mKj3");


var $9UKrO = parcelRequire("9UKrO");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $bQm3c = parcelRequire("bQm3c");


var $eLV9q = parcelRequire("eLV9q");

function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $kSwu1.useIntl)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eLV9q.useGetNavigateToTeamsApp)();
    const { orgId: orgId, userId: requestingUserId } = (0, $bQm3c.useSessionData)();
    const handleProfileCardActions = (0, $cozmU.useCallback)((loggedInUserId)=>(profileCardUserId)=>{
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: undefined,
                    target: '_blank',
                    link: teamsAppPersonProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const providerPromise = (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(userId), featureFlags ?? {});
        if (!((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true))) return providerPromise;
        return providerPromise.then((provider)=>({
                ...provider,
                renderUserMentionCard: ({ userId: mentionUserId, cloudId: mentionCloudId, children: children, referenceElement: referenceElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                        userId: mentionUserId,
                        cloudId: mentionCloudId,
                        orgId: orgId ?? '',
                        viewerId: requestingUserId ?? '',
                        referenceElement: referenceElement,
                        agent: {
                            resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {})
                        }
                    }, children)
            }));
    }, [
        cloudId,
        handleProfileCardActions,
        userId,
        featureFlags,
        orgId,
        requestingUserId
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("26BUI", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5523d8b8240ba692$export$cde76c461119a84c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "31jfw",
    name: "LazySmartlinkAuthNudge",
    loader: async ()=>(await (parcelRequire("dxTIk"))).SmartlinkAuthNudge
});
module.exports["LazySmartlinkAuthNudge"] = $5523d8b8240ba692$export$cde76c461119a84c;

});

parcelRegister("dxTIk", function(module, exports) {

let $9dc99311072827c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9dc99311072827c3$var$load("eQ2E2"),
    $9dc99311072827c3$var$load("hhss7"),
    $9dc99311072827c3$var$load("cL90P"),
    $9dc99311072827c3$var$load("fob67"),
    $9dc99311072827c3$var$load("1sNyt")
]).then(()=>parcelRequire('ddUxf'));

});

parcelRegister("hMB4W", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE = 'INLINE';
const $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH = 100;
// ADF block/container node types cannot be rendered inside an inline macro wrapper.
const $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES = new Set([
    'blockquote',
    (0, $8pcS0.BODIED_EXTENSION_TYPE),
    'bulletList',
    'codeBlock',
    'decisionList',
    'expand',
    (0, $8pcS0.REGULAR_EXTENSION_TYPE),
    'heading',
    'layoutColumn',
    'layoutSection',
    'mediaGroup',
    'mediaSingle',
    (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
    'nestedExpand',
    'orderedList',
    'panel',
    'rule',
    'table',
    'taskList'
]);
const $0cc2e310acfcea5e$var$isAdfLikeNode = (value)=>Boolean(value && typeof value === 'object' && 'type' in value);
const $0cc2e310acfcea5e$var$pushArrayContent = (stack, content, depth)=>{
    for(let index = content.length - 1; index >= 0; index -= 1)stack.push({
        content: content[index],
        depth: depth
    });
};
const $0cc2e310acfcea5e$var$isLegacyContentBlockExtension = (node)=>node.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION && node.type !== (0, $8pcS0.INLINE_EXTENSION_TYPE);
const $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode = (node)=>typeof node.type === 'string' && $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES.has(node.type);
const $0cc2e310acfcea5e$var$containsInlineUnsafeContent = (initialContent)=>{
    const stack = [
        {
            content: initialContent,
            depth: 0
        }
    ];
    const visited = new WeakSet();
    while(stack.length){
        const entry = stack.pop();
        if (!entry) continue;
        const { content: currentContent, depth: depth } = entry;
        if (!currentContent || typeof currentContent === 'string') continue;
        if (depth > $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH) return true;
        if (Array.isArray(currentContent)) {
            $0cc2e310acfcea5e$var$pushArrayContent(stack, currentContent, depth);
            continue;
        }
        if (!$0cc2e310acfcea5e$var$isAdfLikeNode(currentContent)) continue;
        if (visited.has(currentContent)) continue;
        visited.add(currentContent);
        if ($0cc2e310acfcea5e$var$isLegacyContentBlockExtension(currentContent) || $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode(currentContent)) return true;
        stack.push({
            content: currentContent.content,
            depth: depth + 1
        });
        stack.push({
            content: currentContent.attrs?.parameters?.nestedContent,
            depth: depth + 1
        });
    }
    return false;
};
function $0cc2e310acfcea5e$export$6eb9f199796a82af(extensionParams) {
    // Always display excerpt as block
    if (extensionParams?.extensionKey === 'excerpt') return false;
    if ($0cc2e310acfcea5e$var$containsInlineUnsafeContent(extensionParams?.content)) return false;
    const macroParams = extensionParams?.parameters?.macroParams;
    // Connect / pre-migration shape: hyphenated key, value wrapped in { value }.
    if (macroParams?.['atlassian-macro-output-type']?.value === $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE) return true;
    // The camelCased shapes only reach the client on the Forge path.
    const guestParams = extensionParams?.parameters?.guestParams;
    return Boolean(// After Connect->Forge harmonisation the key is camelCased in macroParams
    macroParams?.['atlassianMacroOutputType']?.value === $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE || // Flattened Forge guestParams shape: camelCased key, raw string value
    guestParams?.['atlassianMacroOutputType'] === $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE);
}
module.exports["shouldDisplayExtensionAsInline"] = $0cc2e310acfcea5e$export$6eb9f199796a82af;

});

parcelRegister("3WO8q", function(module, exports) {

var $eL5L2 = parcelRequire("eL5L2");


var $9bZqv = parcelRequire("9bZqv");


var $6s78L = parcelRequire("6s78L");

class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ return (0, $6s78L.mutateInterop)({
            mutation: (0, $eL5L2.default),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            },
            __callerPackage__: "fabric-media-support"
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $9bZqv.i18n).flagTitle),
            description: this.intl.formatMessage((0, $9bZqv.i18n).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}
module.exports["ConfluenceTaskDecisionProvider"] = $cc5c5911f5458682$export$bfe822b045233127;

});

parcelRegister("eL5L2", function(module, exports) {
/**
 * @generated SignedSource<<fe06600cc559f558a289ccb207edd4fd>>
 * @relayHash 71c94317b822094613bae175c3a66d36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74
const $59078742ed079e5f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskId"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "cid",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "taskId",
                            "variableName": "taskId"
                        },
                        {
                            "kind": "Literal",
                            "name": "trigger",
                            "value": "VIEW_PAGE"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "inlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "71c94317b822094613bae175c3a66d36",
            "id": "fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74",
            "metadata": {},
            "name": "SetTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetTaskStatusMutation($contentId:ID!,$taskId:ID!,$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId,taskId:$taskId,status:$status,trigger:VIEW_PAGE}){success}}"
        }
    };
}();
$59078742ed079e5f$var$node.hash = "b0fcb034a764e654bff661127582f078";
var $59078742ed079e5f$export$2e2bcd8739ae039 = $59078742ed079e5f$var$node;
module.exports["default"] = $59078742ed079e5f$export$2e2bcd8739ae039;

});

parcelRegister("9bZqv", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: "An error occurred while trying to change a task\u2019s status. Please try again later."
    }
});
module.exports["i18n"] = $c88a9f0357b47b1b$export$a7357cdd1f0b0168;

});

parcelRegister("gxhb8", function(module, exports) {
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}
module.exports["TaskBatcher"] = $6c53b0825160fdb5$export$9a91b236871b318c;

});

parcelRegister("dXIrr", function(module, exports) {
/* PromptPopupContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $7akNQ = parcelRequire("7akNQ");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $7EIq6 = parcelRequire("7EIq6");


var $cLo2u = parcelRequire("cLo2u");


var $kDja4 = parcelRequire("kDja4");


var $eVXGa = parcelRequire("eVXGa");


var $1xpoY = parcelRequire("1xpoY");


var $bODUD = parcelRequire("bODUD");

const $ded78f64c507c664$var$styles = {
    promptContainer: "_3iDTPbccYA _0hPCNLDIqT _0adFHsFQfX _2XsHFMFQfX"
};
const $ded78f64c507c664$var$VALID_LINK_TYPES = [
    'inline',
    'card',
    'embed'
];
const $ded78f64c507c664$var$WHITEBOARD_COMPETITORS = [
    {
        name: 'Miro',
        domains: [
            /miro\.com/i
        ]
    },
    {
        name: 'Mural',
        domains: [
            /mural\.co/i
        ]
    },
    {
        name: 'Lucid',
        domains: [
            /lucid\.co/i,
            /lucid\.app/i
        ]
    },
    {
        name: 'Microsoft Whiteboard',
        domains: [
            /whiteboard\.office\.com/i,
            /wbd\.ms/i,
            /whiteboard\.cloud\.microsoft/i
        ]
    },
    {
        name: 'Figjam',
        domains: [
            /figma\.com\/board/i
        ]
    },
    {
        name: 'Google Jamboard',
        domains: [
            /jamboard\.google\.com/i
        ]
    },
    // Note: Google Jamboard is EOL
    {
        name: 'Excalidraw',
        domains: [
            /excalidraw\.com/i
        ]
    },
    {
        name: 'Klaxoon',
        domains: [
            /klaxoon\.com/i
        ]
    }
];
const $ded78f64c507c664$var$PromptPopupContainerInner = ({ sourceUrl: sourceUrl, linkType: linkType, editorAppearance: editorAppearance })=>{
    const { data: onboardingStateData, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED
    ], false // skip
    );
    const { isPromptDismissed: isPromptWhiteboardDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData); // Whiteboard competitor eligibility check
    // isCreateWhiteboardEnabled checks if whiteboards are enabled for the space
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    // isWhiteboardFeatureEnabled allows us to check if particular "whiteboard features" are enabled
    // in this case, we are checking if the entire "whiteboard feature" is enabled AND not opted out
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    // useIsAllowedToCreateWhiteboard checks user permissions to create a whiteboard
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const isEligibleCreateNewWhiteboard = isCreateWhiteboardEnabled && isWhiteboardsEnabled && isAllowedToCreateWhiteboard;
    const whiteboardCompetitor = $ded78f64c507c664$var$WHITEBOARD_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(sourceUrl)));
    const whiteboardCompetitorName = isEligibleCreateNewWhiteboard ? whiteboardCompetitor?.name : undefined;
    const competitorContentType = whiteboardCompetitorName ? 'whiteboard' : undefined;
    const competitorName = whiteboardCompetitorName;
    if (!competitorContentType || !competitorName) return null;
    const validLinkType = linkType && $ded78f64c507c664$var$VALID_LINK_TYPES.includes(linkType) ? linkType : undefined;
    const contentTypeConfig = {
        whiteboard: {
            // config to exclude tenants or users from the feature
            // if not excluded, `cc_fd_prompt_competitor_link_config` will return `true`
            // `true` is the default value
            isFeatureEnabled: ()=>(0, $1xpoY.default).getBoolean('cc_fd_prompt_competitor_link_config', true),
            isDismissed: isPromptWhiteboardDismissed
        }
    };
    const { isFeatureEnabled: isFeatureEnabled, isDismissed: isDismissed } = contentTypeConfig[competitorContentType];
    return !loading && !error && !isDismissed && isFeatureEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ded78f64c507c664$var$styles.promptContainer,
        "data-vc": "competitor-link-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bODUD.PromptPopup), {
        competitorName: competitorName,
        linkType: validLinkType,
        contentType: competitorContentType,
        editorAppearance: editorAppearance
    }));
};
const $ded78f64c507c664$export$342f0658478a7894 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ded78f64c507c664$var$PromptPopupContainerInner, props));
module.exports["PromptPopupContainer"] = $ded78f64c507c664$export$342f0658478a7894;

});

parcelRegister("bODUD", function(module, exports) {

var $g2JQG = parcelRequire("g2JQG");


var $4GGYt = parcelRequire("4GGYt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $hBYtq = parcelRequire("hBYtq");


var $w6R6I = parcelRequire("w6R6I");


var $dVbiN = parcelRequire("dVbiN");


var $chu6R = parcelRequire("chu6R");


var $9DHhW = parcelRequire("9DHhW");


var $4MnFz = parcelRequire("4MnFz");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $euL71 = parcelRequire("euL71");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $bMPhU = parcelRequire("bMPhU");


var $cLo2u = parcelRequire("cLo2u");


var $fhofE = parcelRequire("fhofE");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $gC9pJ = parcelRequire("gC9pJ");


var $1tl3n = parcelRequire("1tl3n");


var $60ww2 = parcelRequire("60ww2");

const $02f57d39ae5b5c3c$var$styles = {
    pressable: "_4FKVYE1Y8M _0bjKvDKxmn _39xV02oWWg _0jFU0VoWWg",
    pressableClosed: "_0KLXruB8KG _1eOmH6eJK9",
    pressableOpen: "_32BiAhq6xG _0KLXrueJK9 _3e6OgrLl21"
};
const $02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE = (0, $4GGYt.default);
const $02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE = (0, $g2JQG.default);
const $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS = [
    'miro',
    'mural'
];
const $02f57d39ae5b5c3c$var$PromptComponent = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const [currentPageId] = (0, $ep3mz.usePageContentId)();
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey); // Blogs cannot have child content, so fall back to space homepage
    const parentContentId = currentContentType === 'blogpost' ? homepageId : currentPageId;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $gC9pJ.usePageAnalyticsAttributes)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const isImport = $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS.some((competitor)=>competitorName?.toLowerCase().includes(competitor));
    const { data: paywallData, loading: paywallContentLoading } = (0, $jMyy4.useQueryInterop)($02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE, {
        skip: contentType !== 'whiteboard' || !isImport || edition === (0, $euL71.ConfluenceEdition).PREMIUM,
        fetchPolicy: 'no-cache',
        __callerPackage__: "prompt-competitor-link"
    });
    const paywallContentToDisable = paywallData?.paywallContentToDisable;
    const displayWbImportCta = contentType === 'whiteboard' && isImport && !paywallContentLoading && !(paywallContentToDisable?.deactivationIdentifier && paywallContentToDisable?.link && paywallContentToDisable?.title);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        displayWbImportCta,
        contentType,
        editorAppearance
    ]);
    const [createContentInline, { loading: createContentLoading }] = (0, $308Wd.useMutationInterop)($02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE, {
        onCompleted: (data)=>{
            const contentId = data?.createContentInline?.id;
            if (!contentId) throw Error('no content id present');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceKey,
                    containerType: 'space',
                    source: 'competitorLink',
                    attributes: {
                        flow: 'competitorLink',
                        contentType: contentType,
                        linkType: linkType,
                        isImport: displayWbImportCta ? 'true' : 'false',
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    },
                    nonPrivacySafeAttributes: {
                        linkDomain: competitorName
                    }
                }
            }).fire();
            setOnboardingState({
                key: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
                value: 'true'
            });
            let url = (0, $fhofE.getFullWhiteboardUrl)(contentId, spaceKey);
            if (displayWbImportCta) {
                const urlObj = new URL(url);
                const searchParams = new URLSearchParams(urlObj.search);
                searchParams.set(`open${competitorName}ImportTool`, 'true');
                urlObj.search = searchParams.toString();
                url = urlObj.toString();
            }
            window.open(url, '_blank', 'noreferrer, noopener');
            showFlag?.({
                id: 'competitor-link-success-flag',
                title: intl.formatMessage((0, $1tl3n.i18n).successFlagTitle),
                description: intl.formatMessage((0, $1tl3n.i18n).successFlagDescription),
                isAutoDismiss: false,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: "success"
                }),
                actions: [
                    {
                        content: intl.formatMessage((0, $1tl3n.i18n).successFlagAction),
                        href: url,
                        onClick: ()=>{
                            createAnalyticsEvent({
                                type: 'sendUIEvent',
                                data: {
                                    action: 'clicked',
                                    actionSubject: 'competitorLinkPrompt',
                                    actionSubjectId: 'contentSuccessFlagAction',
                                    source: 'competitorLink',
                                    attributes: {
                                        linkContentType: contentType,
                                        linkType: linkType,
                                        ...pageAnalyticsAttributes
                                    }
                                }
                            }).fire();
                        }
                    }
                ]
            });
        },
        __callerPackage__: "prompt-competitor-link"
    });
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptDismiss',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setOnboardingState({
            key: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
            value: 'true'
        });
    }, [
        setOnboardingState,
        contentType,
        createAnalyticsEvent,
        linkType,
        editorAppearance,
        pageAnalyticsAttributes
    ]);
    const handleLinkClick = async ()=>{
        if (createContentLoading || !parentContentId) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'createButton',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
        await createContentInline({
            variables: {
                createdInContentId: parentContentId,
                spaceKey: spaceKey,
                type: contentType
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60ww2.WhiteboardNudgeContent), {
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        displayImportCta: displayWbImportCta,
        onClickAction: handleLinkClick,
        onDismiss: handleDismiss
    }));
};
const $02f57d39ae5b5c3c$export$79356a2b3ed5a31d = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $gC9pJ.usePageAnalyticsAttributes)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptIcon',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) handlePromptPopupClose();
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'competitorLinkPrompt',
                    actionSubjectId: 'promptIcon',
                    source: 'competitorLink',
                    attributes: {
                        linkContentType: contentType,
                        linkType: linkType,
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    }
                }
            }).fire();
            setIsOpen(!isOpen);
        }
    }, [
        createAnalyticsEvent,
        handlePromptPopupClose,
        isOpen,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    return(// TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        shouldRenderToParent: false,
        isOpen: isOpen,
        onClose: handlePromptPopupClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($02f57d39ae5b5c3c$var$PromptComponent, {
                competitorName: competitorName,
                linkType: linkType,
                contentType: contentType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                onClick: handlePromptPopupClick,
                xcss: (0, $w6R6I.cx)($02f57d39ae5b5c3c$var$styles.pressable, isOpen ? $02f57d39ae5b5c3c$var$styles.pressableOpen : $02f57d39ae5b5c3c$var$styles.pressableClosed),
                testId: "competitor-link-prompt-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
                color: "var(--ds-icon-discovery, #AF59E1)",
                label: intl.formatMessage((0, $1tl3n.i18n).titleWhiteboard)
            }))
    }));
};
module.exports["PromptPopup"] = $02f57d39ae5b5c3c$export$79356a2b3ed5a31d;

});

parcelRegister("g2JQG", function(module, exports) {
/**
 * @generated SignedSource<<b83f28e1481ddab674d916893c028e42>>
 * @relayHash 1f09213993754544aa08c52be2fc631e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006
const $e21fff8b5a3f62da$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f09213993754544aa08c52be2fc631e",
            "id": "ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006",
            "metadata": {},
            "name": "PromptPopupPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query PromptPopupPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$e21fff8b5a3f62da$var$node.hash = "bb7d0d4a20298d54ac0ea3dd0fe0a1fe";
var $e21fff8b5a3f62da$export$2e2bcd8739ae039 = $e21fff8b5a3f62da$var$node;
module.exports["default"] = $e21fff8b5a3f62da$export$2e2bcd8739ae039;

});

parcelRegister("4GGYt", function(module, exports) {
/**
 * @generated SignedSource<<7648391b8de4ac887295688e41a4af1f>>
 * @relayHash 536bd75db3cd2df747c3923dbbdfb5dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1
const $c29180730df60abf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "type"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "536bd75db3cd2df747c3923dbbdfb5dd",
            "id": "a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1",
            "metadata": {},
            "name": "PromptPopupCreateContentInlineMutation",
            "operationKind": "mutation",
            "text": "mutation PromptPopupCreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String,$type:String!){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:$type}){id}}"
        }
    };
}();
$c29180730df60abf$var$node.hash = "7e424a27911cd9ea50caa4b8ef0b5877";
var $c29180730df60abf$export$2e2bcd8739ae039 = $c29180730df60abf$var$node;
module.exports["default"] = $c29180730df60abf$export$2e2bcd8739ae039;

});

parcelRegister("fhofE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $db55d2db1b1085cb$var$BASE_URL_META_SELECTOR = "meta[name='confluence-base-url']";
const $db55d2db1b1085cb$var$getBaseUrlForLocalhost = ()=>{
    const baseUrlFromMeta = window.document.querySelector($db55d2db1b1085cb$var$BASE_URL_META_SELECTOR)?.getAttribute('content') ?? 'https://hello.atlassian.net/wiki';
    return baseUrlFromMeta.substring(0, baseUrlFromMeta.length - 5);
};
const $db55d2db1b1085cb$export$f654b28f82155665 = ()=>{
    if (typeof window.location === 'undefined') return '';
    const baseUrl = window.location.origin;
    // If we are in localhost, we use the base URL from the meta tag
    if (new URL(baseUrl).hostname === 'localhost') return $db55d2db1b1085cb$var$getBaseUrlForLocalhost();
    return baseUrl;
};
const $db55d2db1b1085cb$export$420f191ed44b660f = (contentId, spaceKey)=>`${$db55d2db1b1085cb$export$f654b28f82155665()}${(0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    })}`;
module.exports["getFullWhiteboardUrl"] = $db55d2db1b1085cb$export$420f191ed44b660f;

});

parcelRegister("gC9pJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $48b719f4930c6be4$export$c2b5ddd2c8b4a98c = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    return (0, $cozmU.useMemo)(()=>{
        if (isLivePage) return {
            isLivePage: isLivePage,
            pageMode: livePageMode || 'view' // 'edit' or 'view' for live pages
        };
        return {
            isLivePage: isLivePage,
            pageMode: isEditorPage ? 'edit' : 'view' // 'edit' or 'view' for classic pages
        };
    }, [
        isLivePage,
        livePageMode,
        isEditorPage
    ]);
};
module.exports["usePageAnalyticsAttributes"] = $48b719f4930c6be4$export$c2b5ddd2c8b4a98c;

});

parcelRegister("1tl3n", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6bf1a4c43dd25981$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    titleWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.title-whiteboard",
        defaultMessage: "Try Confluence whiteboards"
    },
    descriptionDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-default-whiteboard",
        defaultMessage: "To brainstorm and ideate without switching tools, try Confluence whiteboards."
    },
    descriptionImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-import-whiteboard",
        defaultMessage: "Reduce context switching by importing your work to a Confluence whiteboard instead."
    },
    createButtonDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-default-whiteboard",
        defaultMessage: "Create a whiteboard"
    },
    createButtonImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-import-whiteboard",
        defaultMessage: "Import from {competitorName}"
    },
    dismissButton: {
        id: "prompt-competitor-link.prompt-whiteboard.dismiss-button",
        defaultMessage: "Do not show for whiteboards again"
    },
    whiteboardIconAltText: {
        id: "prompt-competitor-link.prompt-whiteboard.icon-alt-text",
        defaultMessage: "Confluence Whiteboard"
    },
    successFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-title",
        defaultMessage: "Whiteboard added to content tree"
    },
    successFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-description",
        defaultMessage: "The whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions."
    },
    successFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-action",
        defaultMessage: "Go to whiteboard"
    },
    createdFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-title",
        defaultMessage: "Whiteboard successfully created"
    },
    createdFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-description",
        defaultMessage: "This whiteboard was created as a child item of the content you were working on."
    },
    createdFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-action",
        defaultMessage: "Go back to previous content"
    },
    defaultErrorFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});
module.exports["i18n"] = $6bf1a4c43dd25981$export$a7357cdd1f0b0168;

});

parcelRegister("60ww2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bDjVc = parcelRequire("bDjVc");


var $1tl3n = parcelRequire("1tl3n");


var $jn54I = parcelRequire("jn54I");


var $gC9pJ = parcelRequire("gC9pJ");

const $3309093763baedfe$export$f9c9b82deaeecce8 = ({ competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, displayImportCta: displayImportCta, onClickAction: onClickAction, onDismiss: onDismiss })=>{
    const pageAnalyticsAttributes = (0, $gC9pJ.usePageAnalyticsAttributes)();
    // Determine content based on import CTA
    const descriptionText = displayImportCta ? (0, $1tl3n.i18n).descriptionImportWhiteboard : (0, $1tl3n.i18n).descriptionDefaultWhiteboard;
    const ctaText = displayImportCta ? (0, $1tl3n.i18n).createButtonImportWhiteboard : (0, $1tl3n.i18n).createButtonDefaultWhiteboard;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jn54I.PromptContent), {
        titleText: (0, $1tl3n.i18n).titleWhiteboard,
        descriptionText: descriptionText,
        ctaText: ctaText,
        dismissText: (0, $1tl3n.i18n).dismissButton,
        contentIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        iconColor: "tealBold",
        iconAltText: (0, $1tl3n.i18n).whiteboardIconAltText,
        onClickAction: onClickAction,
        contentType: "whiteboard",
        onDismiss: onDismiss,
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        pageAnalyticsAttributes: pageAnalyticsAttributes
    });
};
module.exports["WhiteboardNudgeContent"] = $3309093763baedfe$export$f9c9b82deaeecce8;

});

parcelRegister("jn54I", function(module, exports) {
/* PromptContent.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $4ez2K = parcelRequire("4ez2K");


var $I7hWB = parcelRequire("I7hWB");


var $lSQgn = parcelRequire("lSQgn");


var $9NPFC = parcelRequire("9NPFC");


var $6TaGl = parcelRequire("6TaGl");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $axjko = parcelRequire("axjko");

const $1a72f80624178457$var$styles = {
    iconContainer: "_2mHwu85zaO",
    titleContainer: "_37wbyuI7V3 _0hPCNLDIqT _39xV02N91d",
    popupBox: "_2XghbE5zaO _39xV02wBC3",
    popupDescription: "_3138422ADO _1DCdHi5zaO",
    textContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0Of8r2FQfX _1wydGWFQfX",
    ctaStyles: "_4FKVYEPgdg _2XghbEPgdg _00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _2sNsIgmnOE _1UtDYzM7Tp _0KLXrujOvk _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    showMoreIcon: "_0KLXru66of"
};
const $1a72f80624178457$export$500652e4aa00ed2f = ({ titleText: titleText, descriptionText: descriptionText, ctaText: ctaText, dismissText: dismissText, contentIcon: ContentIcon, iconColor: iconColor, iconAltText: iconAltText, onClickAction: onClickAction, contentType: contentType, onDismiss: onDismiss, competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, pageAnalyticsAttributes: pageAnalyticsAttributes })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDismissMenuOpen, setIsDismissMenuOpen] = (0, $cozmU.useState)(false);
    const handleMoreMenuClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptMoreMenu',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsDismissMenuOpen(!isDismissMenuOpen);
    };
    const handleDismissClose = ()=>{
        setIsDismissMenuOpen(false);
    };
    const dismissPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        shouldRenderToParent: false,
        isOpen: isDismissMenuOpen,
        onClose: handleDismissClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $axjko.DismissComponent), {
                dismissMessage: dismissText,
                onDismiss: ()=>{
                    onDismiss();
                    handleDismissClose();
                }
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: $1a72f80624178457$var$styles.showMoreIcon,
                onClick: handleMoreMenuClick,
                testId: "competitor-link-prompt-dismiss-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: intl.formatMessage(dismissText),
                size: "medium"
            }))
    });
    const titleSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $1a72f80624178457$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, intl.formatMessage(titleText)), dismissPopup);
    const contentSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1a72f80624178457$var$styles.popupDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage(descriptionText, {
        competitorName: competitorName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onClickAction,
        xcss: $1a72f80624178457$var$styles.ctaStyles
    }, intl.formatMessage(ctaText, {
        competitorName: competitorName
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1a72f80624178457$var$styles.popupBox,
        testId: "competitor-link-prompt-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $1a72f80624178457$var$styles.iconContainer
    }, (0, $9wGTI.fg)('confluence_frontend_tile_object_system_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        key: `${contentType}Icon`,
        testId: `competitor-link-prompt-content-tile-${contentType}`,
        label: intl.formatMessage(iconAltText),
        backgroundColor: "color.background.accent.teal.subtle",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentIcon, {
        size: "small",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        key: `${contentType}Icon`,
        icon: ContentIcon,
        label: intl.formatMessage(iconAltText),
        appearance: iconColor,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1a72f80624178457$var$styles.textContainer
    }, titleSection, contentSection)));
};
module.exports["PromptContent"] = $1a72f80624178457$export$500652e4aa00ed2f;

});

parcelRegister("axjko", function(module, exports) {
/* DismissComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");

const $b04ce10a80ad12d8$var$styles = {
    dismissPressable: "_0KLXruoI2d _0Of8r25zaO _1wydGW5zaO _2Zuz6QNHnM _1ZnuxbNHnM"
};
const $b04ce10a80ad12d8$export$d83330dc6e78fd41 = ({ dismissMessage: dismissMessage, onDismiss: onDismiss })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $b04ce10a80ad12d8$var$styles.dismissPressable,
        onClick: onDismiss,
        testId: "competitor-link-prompt-dismiss-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage(dismissMessage)));
};
module.exports["DismissComponent"] = $b04ce10a80ad12d8$export$d83330dc6e78fd41;

});

parcelRegister("BjpgS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $eDtFr = parcelRequire("eDtFr");


var $fJCU9 = parcelRequire("fJCU9");


var $9FoVw = parcelRequire("9FoVw");


var $8i27m = parcelRequire("8i27m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");

const $fcc85c86573dc170$var$i18n = (0, $kSwu1.defineMessages)({
    viewCommentsLabel: {
        id: "editor-features.media-viewer.view-comments.label",
        defaultMessage: "View comments"
    },
    commentUnavailableTitle: {
        id: "editor-features.media-viewer.comment-unavailable.title",
        defaultMessage: "This comment isn't available"
    },
    commentUnavailableDescription: {
        id: "editor-features.media-viewer.comment-unavailable.description",
        defaultMessage: "It may have been resolved or deleted."
    }
});
const $fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR = '[data-testid="media-viewer-popup"]';
// This function exists because navigating in between previewed elements only uses the file id.
// We need a way to map that back to the annotation ID used by comments, however keeping track of
// this at a global level is likely too heavy relative to usage. Better to just compute on the fly.
function $fcc85c86573dc170$var$findAnnotationForMediaFile(annotationIds, fileId, isViewPage) {
    const activeSet = new Set(annotationIds);
    // Locate the media element directly by file ID.
    // - Renderer nodes use: <div data-node-type="media" data-id="<fileId>">
    // - Editor nodes use:   <div data-prosemirror-node-name="media" id="<fileId>">
    const mediaElement = isViewPage ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`[data-node-type="media"][data-id="${fileId}"]`) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(fileId);
    if (!mediaElement) return undefined;
    // Walk up the DOM to find the enclosing annotation element, but stop once we
    // leave the relevant content root for the current mode.
    let current = mediaElement.parentElement;
    while(current){
        if (current.getAttribute('data-mark-annotation-type') === 'inlineComment') {
            const annotationId = current.id;
            // For view pages the mark must also be in the 'active' state.
            if (isViewPage && current.getAttribute('data-mark-annotation-state') !== 'active') return undefined;
            return activeSet.has(annotationId) ? annotationId : undefined;
        }
        // Once we reach the top of the renderer / editor container, it's safe to assume this element is not within an annotation
        if (isViewPage && current.classList.contains('ak-renderer-wrapper') || !isViewPage && current.classList.contains('ProseMirror')) return undefined;
        current = current.parentElement;
    }
    return undefined;
}
function $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelOpen = false) {
    (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
        annotationIds: [
            annotationId
        ],
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        eventTarget: document.getElementById(annotationId)
    });
    (0, $9FoVw.handleKeyboardShortcutNavigation)({
        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
        block: 'center',
        annotationId: annotationId,
        commentType: 'INLINE',
        isCommentsPanelOpen: isCommentsPanelOpen,
        context: (0, $9FoVw.NavigationContext).RENDERER
    });
}
function $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelOpen = false) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const markElement = document.getElementById(annotationId);
    if (markElement) {
        (0, $gfqXk.getEditorAnnotationEventEmitter)().emit('setselectedannotation', annotationId);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: annotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isCommentsPanelOpen,
            context: (0, $9FoVw.NavigationContext).EDITOR
        });
    }
}
// Used to handle cases where another user removed this comment
function $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, title, description) {
    flags?.showWarningFlag({
        id: 'media-viewer-comment-unavailable',
        title: title,
        description: description
    });
}
const $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS = 2000;
/**
 * Waits for the media viewer popup to be removed from the DOM before invoking `callback`.
 * If the popup is already gone (e.g. it unmounted synchronously), the callback fires on
 * the next animation frame. A safety timeout ensures the callback always fires even if
 * the DOM mutation is never observed.
 */ function $fcc85c86573dc170$var$waitForMediaViewerUnmount(callback) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const popup = document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR);
    if (!popup) {
        // Already unmounted — fire after a rAF to let React finish any pending work.
        requestAnimationFrame(callback);
        return;
    }
    const observer = new MutationObserver(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR)) {
            observer.disconnect();
            clearTimeout(safetyTimer);
            requestAnimationFrame(callback);
        }
    });
    // The media viewer is rendered inside an Atlaskit portal (atlaskit-portal-container),
    // so we observe document.body with subtree:true to catch the removal regardless of
    // how deep in the portal tree the popup lives.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Safety net: if the observer never fires (e.g. the popup is removed in an
    // unexpected way), ensure we still invoke the callback.
    const safetyTimer = window.setTimeout(()=>{
        observer.disconnect();
        callback();
    }, $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS);
}
function $fcc85c86573dc170$export$bd892f36627deebf({ isViewPage: isViewPage, analyticsSource: analyticsSource, flags: flags }) {
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getCurrentCommentsPanelState: getCurrentCommentsPanelState } = (0, $8i27m.useCommentsDataActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_comments_media_preview_integration', 'isEnabled', true)) return undefined;
        const getActiveAnnotationIds = ()=>getCurrentCommentsPanelState().orderedActiveAnnotationIdList?.map(({ threadKey: threadKey })=>threadKey) ?? [];
        return {
            headerActions: [
                {
                    label: intl.formatMessage($fcc85c86573dc170$var$i18n.viewCommentsLabel),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    isVisible: (identifier)=>{
                        // Only show icon when image has comments
                        // NOTE - this is called whenever the header section is rendered (can be multiple times per image), so be careful with non-performant updates!
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return false;
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        return !!annotationId;
                    },
                    onClick: (identifier, actions)=>{
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return;
                        // Re-check on click in case the comment was deleted or resolved after the button rendered.
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        // Fire regardless of outcome, so we can get proper click data
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'mediaPreviewCommentsButton',
                                source: analyticsSource,
                                attributes: {
                                    context: 'mediaViewer',
                                    fileId: identifier.id,
                                    annotationId: annotationId ?? null
                                }
                            }
                        }).fire();
                        if (!annotationId) {
                            $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableTitle), intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableDescription));
                            return;
                        }
                        actions.close();
                        // Defer navigation until after the viewer close has started so selection and scrolling
                        // happen against the underlying page, not the still-open modal.
                        if (isViewPage) requestAnimationFrame(()=>{
                            $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelShown);
                        });
                        else $fcc85c86573dc170$var$waitForMediaViewerUnmount(()=>{
                            $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelShown);
                        });
                    }
                }
            ]
        };
    }, [
        analyticsSource,
        createAnalyticsEvent,
        flags,
        getCurrentCommentsPanelState,
        intl,
        isCommentsPanelShown,
        isViewPage
    ]);
}
module.exports["useMediaCommentExtensions"] = $fcc85c86573dc170$export$bd892f36627deebf;

});

parcelRegister("94rDp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $8wppk = parcelRequire("8wppk");


var $6C7GY = parcelRequire("6C7GY");

const $bb91119414a4e358$export$d8ebe500960648d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { document: document, flags: flags } = t0;
    const [openModalPayload, setOpenModalPayload] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (payload)=>{
            setOpenModalPayload(payload);
        };
        $[0] = t1;
    } else t1 = $[0];
    const onEmbeddedForgeOpenModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setOpenModalPayload(null);
        };
        $[1] = t2;
    } else t2 = $[1];
    const dismissOpenModal = t2;
    let t3;
    let t4;
    if ($[2] !== document || $[3] !== flags) {
        t3 = ()=>{
            if (!document || !(0, $9wGTI.fg)("forge_nbm_connect_to_forge_bridge")) return;
            return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
                onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
            });
        };
        t4 = [
            document,
            flags,
            onEmbeddedForgeOpenModal
        ];
        $[2] = document;
        $[3] = flags;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags || $[7] !== openModalPayload) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6C7GY.EmbeddedForgeMacroModal), {
            payload: openModalPayload,
            flags: flags,
            onDismiss: dismissOpenModal
        });
        $[6] = flags;
        $[7] = openModalPayload;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ document: document, flags: flags })=>{
    const [openModalPayload, setOpenModalPayload] = (0, $cozmU.useState)(null);
    const onEmbeddedForgeOpenModal = (0, $cozmU.useCallback)((payload)=>{
        setOpenModalPayload(payload);
    }, []);
    const dismissOpenModal = (0, $cozmU.useCallback)(()=>{
        setOpenModalPayload(null);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!document || !(0, $9wGTI.fg)('forge_nbm_connect_to_forge_bridge')) return;
        return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
            onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
        });
    }, [
        document,
        flags,
        onEmbeddedForgeOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6C7GY.EmbeddedForgeMacroModal), {
        payload: openModalPayload,
        flags: flags,
        onDismiss: dismissOpenModal
    });
};
module.exports["EmbeddedForgeMacroHost"] = $bb91119414a4e358$export$d8ebe500960648d;

});

parcelRegister("8wppk", function(module, exports) {

var $8z3oB = parcelRequire("8z3oB");

const $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
const $f3689d580c651296$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
const $f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX = 'messageFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX = 'analyticsFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX = 'fetchAppKeyFromEmbeddedFAUS_';
let $f3689d580c651296$var$postRobotOn = null;

if (typeof window !== 'undefined') $f3689d580c651296$var$postRobotOn = (parcelRequire("9rzZK")).postRobotOn;
const $f3689d580c651296$var$getFausDomain = ()=>{
    // allow all domains in development mode
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $f3689d580c651296$var$hasForgeDescendant = (nodes)=>{
    if (!nodes) return false;
    for (const node of nodes){
        if ((node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE) return true;
        if ($f3689d580c651296$var$hasForgeDescendant(node.content)) return true;
    }
    return false;
};
const $f3689d580c651296$var$getConnectMacroIdentifiers = (node)=>{
    const localId = node.attrs?.localId;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value;
    return [
        localId,
        macroId
    ].filter((value)=>typeof value === 'string');
};
/**
 * Walk the ADF tree and return identifiers for Connect bodied macros whose
 * body content contains at least one Forge extension.
 *
 * Note: forwarded FAUS messages currently target the Connect macro's
 * `macroMetadata.macroId.value`, not the ADF node `attrs.localId`.
 */ const $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes)=>{
        for (const node of nodes){
            if (node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE && $f3689d580c651296$var$hasForgeDescendant(node.content)) for (const identifier of $f3689d580c651296$var$getConnectMacroIdentifiers(node))result.add(identifier);
            if (node.content) walk(node.content);
        }
    };
    walk(adf.content);
    return result;
};
/**
 * Walk the ADF tree and return `localId` values for Forge extension nodes
 * (`com.atlassian.ecosystem`) that are nested inside Connect bodied macros.
 *
 * FAUS uses the Forge extension's own `localId` as the channel identifier
 * when forwarding bridge calls via `messageFromEmbeddedFAUS_<localId>`.
 */ const $f3689d580c651296$var$findForgeMacroLocalIds = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes, insideConnectMacro)=>{
        for (const node of nodes){
            const isConnectBodiedMacro = node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE;
            if (insideConnectMacro && (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE && node.attrs?.localId) result.add(node.attrs.localId);
            if (node.content) walk(node.content, insideConnectMacro || isConnectBodiedMacro);
        }
    };
    walk(adf.content, false);
    return result;
};
const $f3689d580c651296$var$buildBridgeEventHandlers = (flagProvider, options)=>{
    const handlers = {};
    if (flagProvider) {
        handlers.showFlag = (payload)=>{
            const actions = payload.actions;
            const flagActions = actions?.map((action)=>({
                    ...action,
                    onClick: action.onClick ? action.onClick : ()=>{}
                }));
            flagProvider.showFlag({
                ...payload,
                actions: flagActions
            });
        };
        handlers.closeFlag = (payload)=>{
            flagProvider.closeFlag(payload);
        };
    }
    if (options?.onEmbeddedForgeOpenModal) {
        const onOpenModal = options.onEmbeddedForgeOpenModal;
        handlers.openModal = (payload)=>{
            // `payload.extension` is required to render the modal — if it's
            // missing the bridge call is malformed and we silently drop it
            // rather than rendering an empty modal.
            if (!payload.extension) return;
            onOpenModal(payload);
        };
    }
    return handlers;
};
/**
 * Register postRobot listeners for a single Connect-macro identifier.
 *
 * Sets up a message channel (`messageFromEmbeddedFAUS_<id>`) that dispatches
 * incoming bridge calls to the matching handler, and an analytics channel
 * (`analyticsFromEmbeddedFAUS_<id>`) that acknowledges events to prevent
 * "No handler found" errors from postRobot.
 *
 * @returns An array of cancel functions for every registered listener.
 */ const $f3689d580c651296$var$setupBridgeListeners = (on, identifier, productHostname, handlers)=>{
    const cancelFns = [];
    const originDomain = $f3689d580c651296$var$getFausDomain();
    const messageHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX}${identifier}`, {
        domain: originDomain
    }, (event)=>{
        const originUrl = new URL(event.origin);
        if (originUrl.hostname !== productHostname) return Promise.resolve();
        const { eventKey: eventKey, ...payload } = event.data ?? {};
        const handler = typeof eventKey === 'string' ? handlers[eventKey] : undefined;
        if (handler) handler(payload);
        return Promise.resolve();
    });
    cancelFns.push(messageHandler.cancel);
    // FAUS also sends a one-shot `analyticsFromEmbeddedFAUS_<id>` message per
    // identifier so embedded Forge apps can forward analytics events (UI, track,
    // operational, screen) to the product. In the normal Forge-in-Forge case this
    // is handled by ForgeUIExtensionPointProvider which has access to the product's
    // AnalyticsWebClient (see ForgeUIExtensionPointProvider.tsx). In the
    // Connect-bodied-macro case there is no parent Forge provider, so we register
    // the listener here to prevent "No handler found" errors from postRobot.
    const analyticsHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX}${identifier}`, {
        domain: originDomain
    }, (_event)=>{
        // TODO: forward events to the Confluence analytics pipeline once an
        // AnalyticsWebClient is plumbed through to this helper.
        // https://product-fabric.atlassian.net/browse/SCALE-8758
        return Promise.resolve();
    });
    cancelFns.push(analyticsHandler.cancel);
    return cancelFns;
};
const $f3689d580c651296$export$2710834bb826f82 = (adf, flags, options)=>{
    if (!$f3689d580c651296$var$postRobotOn) return;
    const connectMacroIdentifiers = $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren(adf);
    const forgeMacroLocalIds = $f3689d580c651296$var$findForgeMacroLocalIds(adf);
    if (connectMacroIdentifiers.size === 0 && forgeMacroLocalIds.size === 0) return;
    const flagProvider = flags ? (0, $8z3oB.getFlagProvider)(flags) : null;
    const productHostname = window.location.hostname;
    const handlers = $f3689d580c651296$var$buildBridgeEventHandlers(flagProvider, options);
    const cancelFns = [];
    for (const identifier of connectMacroIdentifiers)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, identifier, productHostname, handlers));
    for (const forgeMacroLocalId of forgeMacroLocalIds)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, forgeMacroLocalId, productHostname, handlers));
    return ()=>{
        for (const cancel of cancelFns)cancel();
    };
};
const $f3689d580c651296$var$appKeyListenerRegistry = new Map();
const $f3689d580c651296$export$9039814cc3b5c36b = ()=>{
    $f3689d580c651296$var$appKeyListenerRegistry.clear();
};
const $f3689d580c651296$export$22c0e5b0fd0b5778 = (bridgeIdentifier, macroOrigin, macroId, targetWindow)=>{
    if (!$f3689d580c651296$var$postRobotOn || !macroOrigin || !bridgeIdentifier || !macroId) return;
    const requestName = `${$f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX}${bridgeIdentifier}`;
    const appKeyInfo = {
        connectIdentifier: bridgeIdentifier,
        connectMacroOrigin: macroOrigin,
        connectMacroId: macroId
    };
    const existingEntry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
    if (existingEntry) {
        existingEntry.byWindow.set(targetWindow, appKeyInfo);
        return ()=>{
            const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
            if (!entry) return;
            entry.byWindow.delete(targetWindow);
            if (entry.byWindow.size === 0) {
                entry.listenerCancel();
                $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
            }
        };
    }
    const byWindow = new Map();
    byWindow.set(targetWindow, appKeyInfo);
    const listener = $f3689d580c651296$var$postRobotOn(requestName, {
        domain: $f3689d580c651296$var$getFausDomain()
    }, (event)=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry || entry.byWindow.size === 0) return Promise.reject(new Error('No listeners registered for request'));
        const responseFromParent = event.source ? entry.byWindow.get(event.source.parent) : undefined;
        const fallbackResponse = !responseFromParent && entry.byWindow.size === 1 ? entry.byWindow.values().next().value : undefined;
        const response = responseFromParent ?? fallbackResponse;
        if (!response) return Promise.reject(new Error('No listener registered for source window'));
        return Promise.resolve(response);
    });
    $f3689d580c651296$var$appKeyListenerRegistry.set(requestName, {
        listenerCancel: listener.cancel,
        byWindow: byWindow
    });
    return ()=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry) return;
        entry.byWindow.delete(targetWindow);
        if (entry.byWindow.size === 0) {
            entry.listenerCancel();
            $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
        }
    };
};
module.exports["registerEmbeddedMacroListeners"] = $f3689d580c651296$export$2710834bb826f82;
module.exports["registerEmbeddedFausAppKeyListener"] = $f3689d580c651296$export$22c0e5b0fd0b5778;

});

parcelRegister("6C7GY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cVuzC = parcelRequire("cVuzC");


var $jKlwt = parcelRequire("jKlwt");


var $l07HN = parcelRequire("l07HN");


var $hmRc4 = parcelRequire("hmRc4");


var $3jwuS = parcelRequire("3jwuS");


var $bQm3c = parcelRequire("bQm3c");


var $1JyKZ = parcelRequire("1JyKZ");


var $aF5bm = parcelRequire("aF5bm");


var $iop2R = parcelRequire("iop2R");


var $8z3oB = parcelRequire("8z3oB");

const $2c8591f62b6cc876$var$toInternalModalState = (raw)=>{
    const extension = raw.extension;
    if (!extension) return null;
    const onClose = typeof raw.onClose === 'function' ? raw.onClose : undefined;
    return {
        resource: raw.resource ?? undefined,
        size: raw.size,
        context: raw.context,
        closeOnEscape: raw.closeOnEscape,
        closeOnOverlayClick: raw.closeOnOverlayClick,
        onClose: onClose,
        title: raw.title,
        icon: raw.icon,
        embeddedMacroLocalId: raw.embeddedMacroLocalId,
        extension: extension,
        extensionData: raw.extensionData ?? undefined,
        extensionPayload: raw.extensionPayload ?? undefined,
        isEmbeddedMacroModal: Boolean(raw.isEmbeddedMacroModal)
    };
};
const $2c8591f62b6cc876$export$3f2ad537c77fda12 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    bb0: {
        if (!payload) {
            t1 = false;
            break bb0;
        }
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        t1 = Boolean(state?.extension);
    }
    const canRenderModal = t1;
    if (!payload || !canRenderModal) return null;
    let t2;
    if ($[0] !== flags || $[1] !== onDismiss || $[2] !== payload) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
            payload: payload,
            flags: flags,
            onDismiss: onDismiss
        });
        $[0] = flags;
        $[1] = onDismiss;
        $[2] = payload;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const canRenderModal = (0, $cozmU.useMemo)(()=>{
        if (!payload) return false;
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        return Boolean(state?.extension);
    }, [
        payload
    ]);
    if (!payload || !canRenderModal) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
        payload: payload,
        flags: flags,
        onDismiss: onDismiss
    });
};
const $2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(95);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    if ($[0] !== payload) {
        t1 = $2c8591f62b6cc876$var$toInternalModalState(payload);
        $[0] = payload;
        $[1] = t1;
    } else t1 = $[1];
    const modalOptions = t1;
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    let t2;
    if ($[2] !== workspaceARI) {
        t2 = [
            workspaceARI
        ];
        $[2] = workspaceARI;
        $[3] = t2;
    } else t2 = $[3];
    const contextIds = t2;
    const [isReducedMotion, setIsReducedMotion] = (0, $cozmU.useState)(false);
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (typeof window === "undefined") return;
            const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
            setIsReducedMotion(mq.matches);
            const onChange = ()=>setIsReducedMotion(mq.matches);
            mq.addEventListener("change", onChange);
            return ()=>mq.removeEventListener("change", onChange);
        };
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags) {
        t5 = (0, $8z3oB.getFlagProvider)(flags);
        $[6] = flags;
        $[7] = t5;
    } else t5 = $[7];
    const { showFlag: showFlag, closeFlag: closeFlag } = t5;
    const baseExtension = modalOptions?.extension;
    modalOptions?.extensionData;
    let t6;
    if ($[8] !== modalOptions?.extensionData) {
        t6 = modalOptions?.extensionData || {};
        $[8] = modalOptions?.extensionData;
        $[9] = t6;
    } else t6 = $[9];
    const baseExtensionData = t6;
    let t7;
    if ($[10] !== baseExtensionData.content || $[11] !== isLivePage) {
        t7 = baseExtensionData.content ? {
            ...baseExtensionData.content,
            subtype: isLivePage ? "live" : null
        } : undefined;
        $[10] = baseExtensionData.content;
        $[11] = isLivePage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== baseExtensionData || $[14] !== t7) {
        t8 = {
            ...baseExtensionData,
            content: t7
        };
        $[13] = baseExtensionData;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const updatedExtensionData = t8;
    const t9 = baseExtension;
    const t10 = modalOptions?.embeddedMacroLocalId;
    let t11;
    if ($[16] !== contextIds || $[17] !== t10 || $[18] !== t9 || $[19] !== updatedExtensionData) {
        t11 = {
            extension: t9,
            extensionData: updatedExtensionData,
            localId: t10,
            contextIds: contextIds,
            cachingEnabled: true
        };
        $[16] = contextIds;
        $[17] = t10;
        $[18] = t9;
        $[19] = updatedExtensionData;
        $[20] = t11;
    } else t11 = $[20];
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)(t11);
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    modalOptions?.embeddedMacroLocalId;
    let t12;
    bb0: {
        if (!baseExtension) {
            t12 = undefined;
            break bb0;
        }
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        const t13 = modalOptions?.embeddedMacroLocalId || extensionId;
        let t14;
        if ($[21] !== cloudId || $[22] !== environmentId || $[23] !== environmentType || $[24] !== t13) {
            t14 = {
                workspaceId: undefined,
                cloudId: cloudId,
                localId: t13,
                environmentId: environmentId,
                environmentType: environmentType
            };
            $[21] = cloudId;
            $[22] = environmentId;
            $[23] = environmentType;
            $[24] = t13;
            $[25] = t14;
        } else t14 = $[25];
        t12 = t14;
    }
    const coreData = t12;
    let t13;
    if ($[26] !== baseExtension?.properties?.title) {
        t13 = ()=>({
                ThreeLOPrompt: (0, $cVuzC.makeThreeLOPromptForCustomUI)({
                    appName: baseExtension?.properties?.title ?? "",
                    onSuccess: $2c8591f62b6cc876$var$_temp
                })
            });
        $[26] = baseExtension?.properties?.title;
        $[27] = t13;
    } else t13 = $[27];
    baseExtension?.properties?.title;
    const getThreeLOPrompt = t13;
    const onCloseFromModalClass = modalOptions?.onClose;
    let t14;
    if ($[28] !== coreData || $[29] !== modalOptions) {
        t14 = modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ""
            }
        } : {};
        $[28] = coreData;
        $[29] = modalOptions;
        $[30] = t14;
    } else t14 = $[30];
    const embeddedMacroModalProps = t14;
    let t15;
    bb1: {
        if (!coreData || !baseExtension || !modalOptions) {
            t15 = null;
            break bb1;
        }
        const t16 = userId || undefined;
        let t17;
        if ($[31] !== baseExtension || $[32] !== contextIds || $[33] !== coreData || $[34] !== embeddedMacroModalProps || $[35] !== getContextTokenHandler || $[36] !== getThreeLOPrompt || $[37] !== locale || $[38] !== modalOptions.extensionPayload || $[39] !== t16 || $[40] !== updatedExtensionData) {
            t17 = {
                accountId: t16,
                components: getThreeLOPrompt,
                contextIds: contextIds,
                coreData: coreData,
                customBridgeMethods: undefined,
                extension: baseExtension,
                extensionData: updatedExtensionData,
                extensionPayload: modalOptions.extensionPayload,
                extensionViewData: undefined,
                getContextToken: getContextTokenHandler,
                isHidden: false,
                isResizable: false,
                locale: locale,
                timezone: undefined,
                loadingComponent: undefined,
                isEmbeddedMacro: false,
                embeddedParentLocalId: undefined,
                embeddedMacroModalProps: embeddedMacroModalProps
            };
            $[31] = baseExtension;
            $[32] = contextIds;
            $[33] = coreData;
            $[34] = embeddedMacroModalProps;
            $[35] = getContextTokenHandler;
            $[36] = getThreeLOPrompt;
            $[37] = locale;
            $[38] = modalOptions.extensionPayload;
            $[39] = t16;
            $[40] = updatedExtensionData;
            $[41] = t17;
        } else t17 = $[41];
        t15 = t17;
    }
    const iframeProps = t15;
    let t16;
    bb2: {
        if (!iframeProps) {
            t16 = null;
            break bb2;
        }
        t16 = {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }
    const modalIframeProps = t16;
    let t17;
    bb3: {
        if (!modalOptions || !baseExtension) {
            t17 = baseExtension;
            break bb3;
        }
        let t18;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = {};
            $[42] = t18;
        } else t18 = $[42];
        let resourceOverride = t18;
        if (modalOptions?.resource) {
            let t19;
            if ($[43] !== modalOptions.resource) {
                t19 = (0, $l07HN.resolveDynamicResource)(modalOptions.resource);
                $[43] = modalOptions.resource;
                $[44] = t19;
            } else t19 = $[44];
            resourceOverride = t19;
        }
        const t19 = `${baseExtension.type}::dynamic-modal`;
        let t20;
        if ($[45] !== baseExtension.properties || $[46] !== resourceOverride) {
            t20 = {
                ...baseExtension.properties,
                ...resourceOverride
            };
            $[45] = baseExtension.properties;
            $[46] = resourceOverride;
            $[47] = t20;
        } else t20 = $[47];
        let t21;
        if ($[48] !== baseExtension || $[49] !== t19 || $[50] !== t20) {
            t21 = {
                ...baseExtension,
                type: t19,
                properties: t20
            };
            $[48] = baseExtension;
            $[49] = t19;
            $[50] = t20;
            $[51] = t21;
        } else t21 = $[51];
        t17 = t21;
    }
    const extensionInModal = t17;
    let t18;
    bb4: {
        if (!modalOptions || !baseExtension) {
            t18 = updatedExtensionData;
            break bb4;
        }
        const base = modalOptions.extensionData || updatedExtensionData;
        let t19;
        if ($[52] !== modalOptions.context) {
            t19 = modalOptions.context ? {
                modal: modalOptions.context
            } : {};
            $[52] = modalOptions.context;
            $[53] = t19;
        } else t19 = $[53];
        let t20;
        if ($[54] !== baseExtension.type || $[55] !== modalOptions.context) {
            t20 = baseExtension.type.startsWith("jiraServiceManagement") && modalOptions.context ? {
                ...modalOptions.context
            } : {};
            $[54] = baseExtension.type;
            $[55] = modalOptions.context;
            $[56] = t20;
        } else t20 = $[56];
        let t21;
        if ($[57] !== base || $[58] !== t19 || $[59] !== t20) {
            t21 = {
                ...base,
                ...t19,
                ...t20
            };
            $[57] = base;
            $[58] = t19;
            $[59] = t20;
            $[60] = t21;
        } else t21 = $[60];
        t18 = t21;
    }
    const extensionDataInModal = t18;
    let t19;
    if ($[61] !== onDismiss) {
        t19 = ()=>{
            onDismiss();
        };
        $[61] = onDismiss;
        $[62] = t19;
    } else t19 = $[62];
    const handleModalTearDown = t19;
    let t20;
    if ($[63] !== handleModalTearDown || $[64] !== isReducedMotion || $[65] !== onCloseFromModalClass) {
        t20 = ()=>{
            onCloseFromModalClass?.();
            if (isReducedMotion) handleModalTearDown();
        };
        $[63] = handleModalTearDown;
        $[64] = isReducedMotion;
        $[65] = onCloseFromModalClass;
        $[66] = t20;
    } else t20 = $[66];
    const handleModalClose = t20;
    let t21;
    let t22;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $hmRc4.getBrowserHistory)();
        t22 = (callback)=>{
            setViewOnClose(()=>callback.data);
            return true;
        };
        $[67] = t21;
        $[68] = t22;
    } else {
        t21 = $[67];
        t22 = $[68];
    }
    let t23;
    if ($[69] !== onCloseFromModalClass) {
        t23 = (closePayload)=>{
            onCloseFromModalClass?.(closePayload?.data);
            return true;
        };
        $[69] = onCloseFromModalClass;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== closeFlag || $[72] !== showFlag || $[73] !== t23) {
        t24 = {
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: t21,
            onClose: t22,
            close: t23
        };
        $[71] = closeFlag;
        $[72] = showFlag;
        $[73] = t23;
        $[74] = t24;
    } else t24 = $[74];
    const bridge = t24;
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    const t25 = modalOptions.embeddedMacroLocalId ?? baseExtension.id;
    const t26 = modalOptions.size;
    const t27 = modalOptions.title;
    const t28 = modalOptions.icon;
    const t29 = modalOptions.closeOnEscape;
    const t30 = modalOptions.closeOnOverlayClick;
    let t31;
    if ($[75] !== cloudId || $[76] !== environment || $[77] !== userId) {
        t31 = (0, $iop2R.getMentionProvider)(cloudId, environment, userId);
        $[75] = cloudId;
        $[76] = environment;
        $[77] = userId;
        $[78] = t31;
    } else t31 = $[78];
    let t32;
    if ($[79] !== bridge || $[80] !== extensionDataInModal || $[81] !== extensionInModal || $[82] !== getThreeLOPrompt || $[83] !== handleModalClose || $[84] !== handleModalTearDown || $[85] !== iframeProps || $[86] !== modalOptions.closeOnEscape || $[87] !== modalOptions.closeOnOverlayClick || $[88] !== modalOptions.icon || $[89] !== modalOptions.size || $[90] !== modalOptions.title || $[91] !== t25 || $[92] !== t31 || $[93] !== viewOnClose) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.ModalCustomUIRenderer), {
            ...iframeProps,
            product: "confluence",
            getThreeLOPrompt: getThreeLOPrompt,
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: t25,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            modalOnClose: handleModalClose,
            size: t26,
            title: t27,
            icon: t28,
            closeOnEscape: t29,
            closeOnOverlayClick: t30,
            getModalWidth: undefined,
            isIframeResizable: false,
            viewOnClose: viewOnClose,
            mentionProvider: t31
        });
        $[79] = bridge;
        $[80] = extensionDataInModal;
        $[81] = extensionInModal;
        $[82] = getThreeLOPrompt;
        $[83] = handleModalClose;
        $[84] = handleModalTearDown;
        $[85] = iframeProps;
        $[86] = modalOptions.closeOnEscape;
        $[87] = modalOptions.closeOnOverlayClick;
        $[88] = modalOptions.icon;
        $[89] = modalOptions.size;
        $[90] = modalOptions.title;
        $[91] = t25;
        $[92] = t31;
        $[93] = viewOnClose;
        $[94] = t32;
    } else t32 = $[94];
    return t32;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const modalOptions = (0, $cozmU.useMemo)(()=>$2c8591f62b6cc876$var$toInternalModalState(payload), [
        payload
    ]);
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const contextIds = (0, $cozmU.useMemo)(()=>[
            workspaceARI
        ], [
        workspaceARI
    ]);
    const [isReducedMotion, setIsReducedMotion] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        setIsReducedMotion(mq.matches);
        const onChange = ()=>setIsReducedMotion(mq.matches);
        mq.addEventListener('change', onChange);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $8z3oB.getFlagProvider)(flags);
    const baseExtension = modalOptions?.extension;
    const updatedExtensionData = (0, $cozmU.useMemo)(()=>{
        const baseExtensionData = modalOptions?.extensionData || {};
        return {
            ...baseExtensionData,
            content: baseExtensionData.content ? {
                ...baseExtensionData.content,
                subtype: isLivePage ? 'live' : null
            } : undefined
        };
    }, [
        isLivePage,
        modalOptions?.extensionData
    ]);
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)({
        extension: baseExtension,
        extensionData: updatedExtensionData,
        localId: modalOptions?.embeddedMacroLocalId,
        contextIds: contextIds,
        cachingEnabled: true
    });
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    const coreData = (0, $cozmU.useMemo)(()=>{
        if (!baseExtension) return undefined;
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        return {
            workspaceId: undefined,
            cloudId: cloudId,
            localId: modalOptions?.embeddedMacroLocalId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        };
    }, [
        baseExtension,
        cloudId,
        modalOptions?.embeddedMacroLocalId
    ]);
    const getThreeLOPrompt = (0, $cozmU.useCallback)(()=>{
        return {
            ThreeLOPrompt: (0, $cVuzC.makeThreeLOPromptForCustomUI)({
                appName: baseExtension?.properties?.title ?? '',
                onSuccess: ()=>{}
            })
        };
    }, [
        baseExtension?.properties?.title
    ]);
    const onCloseFromModalClass = modalOptions?.onClose;
    // Memoised so the object identity is stable across renders. Without this,
    // every render produces a fresh `{}` and any downstream useMemo that lists
    // `embeddedMacroModalProps` in its deps would invalidate on every render.
    const embeddedMacroModalProps = (0, $cozmU.useMemo)(()=>modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ''
            }
        } : {}, [
        coreData,
        modalOptions
    ]);
    const iframeProps = (0, $cozmU.useMemo)(()=>{
        if (!coreData || !baseExtension || !modalOptions) return null;
        return {
            accountId: userId || undefined,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            coreData: coreData,
            customBridgeMethods: undefined,
            extension: baseExtension,
            extensionData: updatedExtensionData,
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            getContextToken: getContextTokenHandler,
            isHidden: false,
            isResizable: false,
            locale: locale,
            timezone: undefined,
            loadingComponent: undefined,
            isEmbeddedMacro: false,
            embeddedParentLocalId: undefined,
            embeddedMacroModalProps: embeddedMacroModalProps
        };
    }, [
        baseExtension,
        contextIds,
        coreData,
        getContextTokenHandler,
        getThreeLOPrompt,
        locale,
        modalOptions,
        updatedExtensionData,
        userId,
        embeddedMacroModalProps
    ]);
    const modalIframeProps = (0, $cozmU.useMemo)(()=>{
        if (!iframeProps) return null;
        return {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }, [
        embeddedMacroModalProps,
        iframeProps
    ]);
    const extensionInModal = (0, $cozmU.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return baseExtension;
        // `openModal`'s resource is optional; only override when one is explicitly provided. When it is
        // omitted the modal defaults to the current resource, so we inherit it (and its entry) untouched.
        let resourceOverride = {};
        if (modalOptions?.resource) resourceOverride = (0, $l07HN.resolveDynamicResource)(modalOptions.resource);
        return {
            ...baseExtension,
            type: `${baseExtension.type}::dynamic-modal`,
            properties: {
                ...baseExtension.properties,
                ...resourceOverride
            }
        };
    }, [
        baseExtension,
        modalOptions
    ]);
    const extensionDataInModal = (0, $cozmU.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return updatedExtensionData;
        const base = modalOptions.extensionData || updatedExtensionData;
        return {
            ...base,
            ...modalOptions.context ? {
                modal: modalOptions.context
            } : {},
            ...baseExtension.type.startsWith('jiraServiceManagement') && modalOptions.context ? {
                ...modalOptions.context
            } : {}
        };
    }, [
        baseExtension,
        modalOptions,
        updatedExtensionData
    ]);
    const handleModalTearDown = (0, $cozmU.useCallback)(()=>{
        onDismiss();
    }, [
        onDismiss
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        onCloseFromModalClass?.();
        if (isReducedMotion) handleModalTearDown();
    }, [
        handleModalTearDown,
        isReducedMotion,
        onCloseFromModalClass
    ]);
    const bridge = (0, $cozmU.useMemo)(()=>({
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: (0, $hmRc4.getBrowserHistory)(),
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data);
                return true;
            },
            close: (closePayload)=>{
                onCloseFromModalClass?.(closePayload?.data);
                return true;
            }
        }), [
        closeFlag,
        onCloseFromModalClass,
        showFlag
    ]);
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.ModalCustomUIRenderer), {
        ...iframeProps,
        product: "confluence",
        getThreeLOPrompt: getThreeLOPrompt,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions.embeddedMacroLocalId ?? baseExtension.id,
        onTearDown: handleModalTearDown,
        bridge: bridge,
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        getModalWidth: undefined,
        isIframeResizable: false,
        viewOnClose: viewOnClose,
        mentionProvider: (0, $iop2R.getMentionProvider)(cloudId, environment, userId)
    });
};
function $2c8591f62b6cc876$var$_temp() {}
module.exports["EmbeddedForgeMacroModal"] = $2c8591f62b6cc876$export$3f2ad537c77fda12;

});

parcelRegister("6Trhx", function(module, exports) {

var $2ELXv = parcelRequire("2ELXv");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $6mKj3 = parcelRequire("6mKj3");


var $c0rhi = parcelRequire("c0rhi");

const $16afe942cafdcc72$var$PAGE_SIZE = 50;
// setting max iterations to avoid ever getting into an infinite loop just in case
const $16afe942cafdcc72$var$MAX_ITERATIONS = 50;
const $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode = (0, $2ELXv.default);
const $16afe942cafdcc72$var$ANALYTICS_SOURCE = 'fallbackMediaNameFetcher';
const $16afe942cafdcc72$export$8632f0c995082e2a = (contentId, { mediaProvider: mediaProvider, createAnalyticsEvent: createAnalyticsEvent } = {})=>async (id)=>{
        let offset = 0;
        let iterations = 0;
        let hasNextPage = true;
        while(hasNextPage && iterations < $16afe942cafdcc72$var$MAX_ITERATIONS){
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode,
                variables: {
                    contentId: contentId,
                    offset: offset,
                    first: $16afe942cafdcc72$var$PAGE_SIZE
                },
                fetchPolicy: 'cache-first',
                __callerPackage__: "editor-features"
            }).catch((e)=>{
                if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                return {
                    data: null
                };
            });
            const attachments = data?.content?.edges?.[0]?.node?.attachments;
            const nodes = attachments?.nodes ?? [];
            for (const node of nodes){
                const fileId = node?.extensions?.find((ext)=>ext?.key === 'fileId')?.value;
                if (fileId === id && node?.title) {
                    const fileName = node.title;
                    if ((0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true)) {
                        createAnalyticsEvent?.({
                            type: 'sendOperationalEvent',
                            data: {
                                action: 'resolved',
                                actionSubject: 'mediaFileName',
                                source: $16afe942cafdcc72$var$ANALYTICS_SOURCE
                            }
                        })?.fire();
                        if (mediaProvider) mediaProvider.then((provider)=>provider.renameFile?.(id, fileName)).catch((error)=>{
                            createAnalyticsEvent?.({
                                type: 'sendOperationalEvent',
                                data: {
                                    action: 'failed',
                                    actionSubject: 'mediaFileRename',
                                    source: $16afe942cafdcc72$var$ANALYTICS_SOURCE,
                                    attributes: {
                                        errorMessage: error instanceof Error ? error.message : 'Error renaming file'
                                    }
                                }
                            })?.fire();
                        });
                    }
                    return fileName;
                }
            }
            hasNextPage = attachments?.pageInfo?.hasNextPage ?? false;
            offset += $16afe942cafdcc72$var$PAGE_SIZE;
            iterations += 1;
        }
        if ((0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true)) createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'notFound',
                actionSubject: 'mediaFileName',
                source: $16afe942cafdcc72$var$ANALYTICS_SOURCE,
                attributes: {
                    pagesScanned: iterations
                }
            }
        })?.fire();
        throw new Error(`Attachment with fileId ${id} not found on page ${contentId}`);
    };
module.exports["createFallbackMediaNameFetcher"] = $16afe942cafdcc72$export$8632f0c995082e2a;

});

parcelRegister("2ELXv", function(module, exports) {
/**
 * @generated SignedSource<<7b142a9e5bf037e5bf84df26b0f166d8>>
 * @relayHash 5cd532f1dbaa98f680938803d44a7622
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3
const $8905400aadac7d47$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5cd532f1dbaa98f680938803d44a7622",
            "id": "e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3",
            "metadata": {},
            "name": "fallbackMediaNameFetcherQuery",
            "operationKind": "query",
            "text": "query fallbackMediaNameFetcherQuery($contentId:ID!,$offset:Int,$first:Int){content(id:$contentId,status:[\"current\",\"draft\"]){edges{node{attachments(first:$first,offset:$offset){nodes{title,extensions{key,value},id},pageInfo{hasNextPage}},id}}}}"
        }
    };
}();
$8905400aadac7d47$var$node.hash = "86d114dcacd8ef1cb2ec5aab70e98d80";
var $8905400aadac7d47$export$2e2bcd8739ae039 = $8905400aadac7d47$var$node;
module.exports["default"] = $8905400aadac7d47$export$2e2bcd8739ae039;

});

parcelRegister("edEsl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ 
var $hfrng = parcelRequire("hfrng");


var $04e9M = parcelRequire("04e9M");


var $9wGTI = parcelRequire("9wGTI");

const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$isDownloadEvent = (options)=>(0, $9wGTI.fg)('confluence_publish_attachment_audit_log_event') && options.viewingLevel === 'download';
const $027ba4852fb11225$var$getNotifyRequestBody = (options)=>{
    if ($027ba4852fb11225$var$isDownloadEvent(options)) return {
        attachmentDownloaded: {
            fileStoreId: options.fileId
        }
    };
    return {
        attachmentViewed: {
            fileStoreId: options.fileId
        }
    };
};
const $027ba4852fb11225$var$getTrackEventPayload = (options, contentType)=>{
    const action = $027ba4852fb11225$var$isDownloadEvent(options) ? 'downloaded' : 'viewed';
    return {
        source: 'ui',
        actionSubject: 'attachment',
        action: action,
        name: `attachment ${action}`,
        attributes: {
            activationId: options.fileId,
            pageType: contentType
        }
    };
};
const $027ba4852fb11225$var$globalMediaViewedListener = (options, contentType)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = (0, $9wGTI.fg)('confluence_event_notifier_deprecation') ? Promise.resolve({}) : fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify($027ba4852fb11225$var$getNotifyRequestBody(options)),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if ((0, $9wGTI.fg)('confluence_event_notifier_updates')) (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendTrackEvent($027ba4852fb11225$var$getTrackEventPayload(options, contentType));
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
// Reference count of registrants sharing the singleton listener (view renderers, comment renderers,
// the editor). Only detach on the last remove, so one unmount can't kill the listener for others.
let $027ba4852fb11225$var$registrationCount = 0;
// make sure currentListener is a stable reference so it can be removed by .off event handler
let $027ba4852fb11225$var$currentListener = null;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ({ contentType: contentType })=>{
    if ($027ba4852fb11225$var$registrationCount === 0) {
        $027ba4852fb11225$var$currentListener = (options)=>{
            $027ba4852fb11225$var$globalMediaViewedListener(options, contentType);
        };
        (0, $hfrng.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$currentListener);
    }
    $027ba4852fb11225$var$registrationCount += 1;
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    if ($027ba4852fb11225$var$registrationCount === 0) return;
    $027ba4852fb11225$var$registrationCount -= 1;
    if ($027ba4852fb11225$var$registrationCount === 0 && $027ba4852fb11225$var$currentListener) {
        (0, $hfrng.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$currentListener = null;
    }
};
module.exports["registerGlobalMediaViewedListener"] = $027ba4852fb11225$export$dbbc14ed63c88dd4;
module.exports["removeGlobalMediaViewedListener"] = $027ba4852fb11225$export$29046bd16724fad9;

});

parcelRegister("5hfGu", function(module, exports) {

var $04e9M = parcelRequire("04e9M");


var $eXfot = parcelRequire("eXfot");


var $6s78L = parcelRequire("6s78L");

async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        return await (0, $6s78L.mutateInterop)({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch,
            __callerPackage__: "adf-renderer"
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}
module.exports["batchTaskUpdate"] = $ad68e9e7df73622d$export$ee66267d3930a21;

});

parcelRegister("eXfot", function(module, exports) {

var $cBXBC = parcelRequire("cBXBC");

const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $cBXBC.default);
module.exports["SetBatchedTaskStatusMutation"] = $408d997ca1cff4e4$export$2fe8e9e635ca9d7a;

});

parcelRegister("cBXBC", function(module, exports) {
/**
 * @generated SignedSource<<8ed8dc03028e55b4cdab4438310d33a6>>
 * @relayHash 3f8b7bb91ace1543a1f04562b04091b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930
const $0c16356697ac10ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tasks"
        },
        {
            "defaultValue": "VIEW_PAGE",
            "kind": "LocalArgument",
            "name": "trigger"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "tasks",
                            "variableName": "tasks"
                        },
                        {
                            "kind": "Variable",
                            "name": "trigger",
                            "variableName": "trigger"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "batchedInlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setBatchedTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f8b7bb91ace1543a1f04562b04091b2",
            "id": "a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930",
            "metadata": {},
            "name": "SetBatchedTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetBatchedTaskStatusMutation($contentId:ID!,$tasks:[InlineTask]!,$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId,tasks:$tasks,trigger:$trigger}){success}}"
        }
    };
}();
$0c16356697ac10ff$var$node.hash = "69534ca77b812c2f6a503bd25527650c";
var $0c16356697ac10ff$export$2e2bcd8739ae039 = $0c16356697ac10ff$var$node;
module.exports["default"] = $0c16356697ac10ff$export$2e2bcd8739ae039;

});

parcelRegister("9VON8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "26C7v",
    name: "ViewPageAttachmentForgeActionsPortalLoader",
    loader: async ()=>(await (parcelRequire("5IQv3"))).ViewPageAttachmentForgeActionsPortal
});
$05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader.displayName = 'lazy(ViewPageAttachmentForgeActionsPortal)';
const $05271241466f5e2e$export$b8cbd42b7b7bd9d2 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, contentType: contentType, isViewPage: isViewPage, spaceKey: spaceKey } = t0;
    if (!isViewPage || !contentId || !spaceKey || !contentType || !(0, $9wGTI.fg)("forge_attachment_display_conditions")) return null;
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== isViewPage || $[3] !== spaceKey) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader, {
            contentId: contentId,
            contentType: contentType,
            isViewPage: isViewPage,
            spaceKey: spaceKey
        });
        $[0] = contentId;
        $[1] = contentType;
        $[2] = isViewPage;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
module.exports["LazyViewPageAttachmentForgeActionsPortal"] = $05271241466f5e2e$export$b8cbd42b7b7bd9d2;

});

parcelRegister("5IQv3", function(module, exports) {

let $42a9c93584d3a986$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42a9c93584d3a986$var$load("6wr18"),
    $42a9c93584d3a986$var$load("ffEVr"),
    $42a9c93584d3a986$var$load("8VYL2")
]).then(()=>parcelRequire('yAmxl'));

});


$parcel$global.rlb("evJG0")
//# sourceMappingURL=CommentEditor.1526d1b7.js.map
